// Wrapped in an IIFE so the declarations below live in a function scope rather
// than a bare block. Block-level function declarations fall under Annex B, which
// Safari <=17 mis-resolves once minified (SHOPIFY-1GH).
(function () {
        if (typeof window.__DELIVERY_MODAL_LOADED !== 'undefined') return;
            window.__DELIVERY_MODAL_LOADED = true;
            
            const LOCATION_PRICE_CACHE_KEY = window.LOCATION_PRICE_CACHE_KEY || "location_price_list";
            const LOCATION_PRICE_CACHE_TTL_MS = window.LOCATION_PRICE_CACHE_TTL_MS || (30 * 60 * 1000); // 30 minutes
            const API_URL = window.API_URL || (window.EveryTable?.api?.baseUrl || "https://admin-app.everytable-sh.com/api");
            const LOCATION_CATALOG_CACHE_KEY = window.LOCATION_CATALOG_CACHE_KEY || "location_catalog_json";
            const LOCATION_CATALOG_CACHE_TTL_MS = window.LOCATION_CATALOG_CACHE_TTL_MS || (10 * 60 * 1000); // 10 minutes
            const DEFAULT_DELIVERY_ZIP_CODE = window.DEFAULT_DELIVERY_ZIP_CODE || "90001";
            
            // Store on window to make them globally accessible
            window.LOCATION_PRICE_CACHE_KEY = LOCATION_PRICE_CACHE_KEY;
            window.LOCATION_PRICE_CACHE_TTL_MS = LOCATION_PRICE_CACHE_TTL_MS;
            window.API_URL = API_URL;
            window.LOCATION_CATALOG_CACHE_KEY = LOCATION_CATALOG_CACHE_KEY;
            window.LOCATION_CATALOG_CACHE_TTL_MS = LOCATION_CATALOG_CACHE_TTL_MS;
            window.DEFAULT_DELIVERY_ZIP_CODE = DEFAULT_DELIVERY_ZIP_CODE;

        var _resumeCatalogRefreshInFlight = null;
        var __fulfillmentModalCancelledFallback = false;

        // Declared with `var` so they have no temporal dead zone at all: the 113
        // function declarations below hoist above this point and some run during
        // script evaluation (Safari surfaced this as ReferenceError; SHOPIFY-1GH).
        var latestZipRequestId = 0;
        var lastZipRequestValue = '';
        var lastZipRequestAt = 0;
        var deliveryOptionManuallyChosen = false;
        // Guard to prevent multiple simultaneous browseMeals() calls
        var isBrowseMealsExecuting = false;
        const FulfillmentState = new Proxy(
            {},
            {
                get: function (_target, prop) {
                    var fs = window.FulfillmentState;
                    if (fs) {
                        var val = fs[prop];
                        return typeof val === 'function' ? val.bind(fs) : val;
                    }
                    if (prop === '_modalCancelled') return __fulfillmentModalCancelledFallback;
                    if (prop === 'get') {
                        return function (key) {
                            try {
                                return localStorage.getItem(key);
                            } catch (e) {
                                return null;
                            }
                        };
                    }
                    if (prop === 'set') {
                        return function (key, value) {
                            try {
                                if (value == null) localStorage.removeItem(key);
                                else localStorage.setItem(key, String(value));
                            } catch (e) {}
                        };
                    }
                    if (prop === 'remove') {
                        return function (key) {
                            try {
                                localStorage.removeItem(key);
                            } catch (e) {}
                        };
                    }
                    if (prop === 'isDraftMode' || prop === 'isReady') {
                        return function () {
                            return false;
                        };
                    }
                    if (prop === 'snapshot' || prop === 'restore' || prop === 'commit') {
                        return function () {};
                    }
                    return undefined;
                },
                set: function (_target, prop, value) {
                    var fs = window.FulfillmentState;
                    if (fs) {
                        try {
                            fs[prop] = value;
                        } catch (e) {}
                    } else if (prop === '_modalCancelled') {
                        __fulfillmentModalCancelledFallback = value;
                    }
                    return true;
                },
            }
        );

        function isFulfillmentDraftMode() {
            return !!(window.FulfillmentState &&
                typeof window.FulfillmentState.isDraftMode === 'function' &&
                window.FulfillmentState.isDraftMode());
        }

        function dispatchCommittedFulfillmentDateChanged(date) {
            if (!date) return;
            if (isFulfillmentDraftMode()) return;
            const detail = { detail: { date } };
            try {
                document.dispatchEvent(new CustomEvent('fulfillmentDateChanged', detail));
            } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('fulfillmentDateChanged', detail));
            } catch (e2) {}
        }

        function dispatchCommittedLocationChanged() {
            if (isFulfillmentDraftMode()) return;
            try {
                document.dispatchEvent(new CustomEvent('locationChanged', { bubbles: true }));
            } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('locationChanged'));
            } catch (e2) {}
        }

        function dispatchCommittedLocationPricesReady() {
            if (isFulfillmentDraftMode()) return;
            try {
                window.dispatchEvent(new Event('locationPricesReady'));
            } catch (e) {}
        }

        // Utility function to show/hide zip error
        function showZipError(message) {
            const zipError = document.getElementById('zip-error');
            if (zipError) {
                zipError.textContent = message;
                zipError.classList.remove('hidden');
            }
        }

        function hideZipError() {
            const zipError = document.getElementById('zip-error');
            if (zipError) {
                zipError.classList.add('hidden');
            }
        }

        function getFulfillmentStateValue(key) {
            if (window.FulfillmentState && typeof window.FulfillmentState.get === 'function') {
                const value = window.FulfillmentState.get(key);
                if (value !== null && value !== undefined) {
                    return String(value);
                }
                return '';
            }
            const raw = localStorage.getItem(key);
            return raw == null ? '' : String(raw);
        }

        function escapeHtmlAttribute(value) {
            return String(value == null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }

        async function readErrorResponseBody(response) {
            try {
                return await response.text();
            } catch (error) {
                return '';
            }
        }

        async function prefetchCatalogPricingCache(locationId, locationName) {
            try {
                if (!locationId || !locationName) return;
                const cacheKey = `location_catalog_json-${locationId}`;
                const existingRaw = localStorage.getItem(cacheKey);
                if (existingRaw) {
                    try {
                        const existing = JSON.parse(existingRaw);
                        const ageMs = Date.now() - (Number(existing.timestamp) || 0);
                        if (ageMs >= 0 && ageMs < LOCATION_CATALOG_CACHE_TTL_MS) {
                            return;
                        }
                    } catch (e) {}
                }

                const response = await fetch(`${API_URL}/location/catalog/${locationId}/${encodeURIComponent(locationName)}`);
                if (!response.ok) return;
                const json = await response.json();
                const catalog = json?.catalog;
                if (!catalog) return;
                localStorage.setItem(cacheKey, JSON.stringify({
                    data: { catalog: catalog },
                    timestamp: Date.now(),
                    locationId: String(locationId),
                    locationName: String(locationName || '')
                }));
            } catch (e) {}
        }

        // Helper function to handle delivery to pickup switch
        async function handleDeliveryToPickupSwitch() {
            // Ensure pickup location is selected
            const selectedPickupRadio = document.querySelector('input[name="pickup-location"]:checked');
            if (!selectedPickupRadio) {
                const firstPickupRadio = document.querySelector('input[name="pickup-location"]');
                if (firstPickupRadio) {
                    firstPickupRadio.checked = true;
                    firstPickupRadio.dispatchEvent(new Event('change'));
                }
            }

            // Preselect the selected_location_id
            const selectedLocationId = localStorage.getItem('selected_location_id');
            if(selectedLocationId) {
                const selectedLocationRadio = document.querySelector(`input[name="pickup-location"][data-location-id="${selectedLocationId}"]`);
                if(selectedLocationRadio) {
                    selectedLocationRadio.checked = true;
                    selectedLocationRadio.dispatchEvent(new Event('change'));
                }
            }

            // Update pickup dates if needed
            const pickupDateSelect = document.getElementById('fulfillment-date-pickup');
            if (pickupDateSelect && pickupDateSelect.options.length > 0) {
                // Validate that the selected date is not expired (using store timezone)
                const selectedPickupDate = pickupDateSelect.value;
                
                // If selected date is expired, select first available date
                if (isDateTimePast(selectedPickupDate, null)) {
                    for (let i = 0; i < pickupDateSelect.options.length; i++) {
                        if (!pickupDateSelect.options[i].disabled) {
                            pickupDateSelect.value = pickupDateSelect.options[i].value;
                            break;
                        }
                    }
                }
                
                FulfillmentState.set('selected_fulfillment_date', pickupDateSelect.value);
                dispatchCommittedFulfillmentDateChanged(pickupDateSelect.value);
            }
        }

        // Helper function to handle pickup to delivery switch
        async function handlePickupToDeliverySwitch() {
            // Ensure delivery date is selected
            const zipCacheKey = Object.keys(sessionStorage).find(k => k.startsWith('zipCache-'));
            if (zipCacheKey) {
                const cachedData = sessionStorage.getItem(zipCacheKey);
                if (cachedData) {
                    try {
                        const parsed = JSON.parse(cachedData);
                        const payload = parsed?.data || parsed;
                        if (payload?.deliveryLocation && typeof payload.deliveryLocation.location_id !== 'undefined') {
                            FulfillmentState.set('selected_location_id', payload.deliveryLocation.location_id);
                        }
                    } catch (e) {
                        sessionStorage.removeItem(zipCacheKey);
                    }
                }
            }

            const deliveryDateSelect = document.getElementById('fulfillment-date-delivery');
            if (deliveryDateSelect && deliveryDateSelect.options.length > 0) {
                // Validate that the selected date is not expired (using store timezone)
                const selectedDeliveryDate = deliveryDateSelect.value;
                
                // If selected date is expired, select first available date
                if (isDateTimePast(selectedDeliveryDate, null)) {
                    for (let i = 0; i < deliveryDateSelect.options.length; i++) {
                        if (!deliveryDateSelect.options[i].disabled) {
                            deliveryDateSelect.value = deliveryDateSelect.options[i].value;
                            break;
                        }
                    }
                }
                
                FulfillmentState.set('selected_fulfillment_date', deliveryDateSelect.value);
                dispatchCommittedFulfillmentDateChanged(deliveryDateSelect.value);
            }
            
            // Ensure zip code is set for delivery - only if it's valid
            const zipInput = document.getElementById('zip');
            if (zipInput && zipInput.value.trim()) {
                const zipValue = zipInput.value.trim();

                if (/^\d{5}$/.test(zipValue)) {
                    const cachedData = getCachedZipData(zipValue);
                    if (cachedData && cachedData.deliveryLocation && cachedData.deliveryLocation.name && cachedData.deliveryLocation.location_id) {
                        FulfillmentState.set('selected_zip_code', zipValue);
                    } else {
                        try {
                            const res = await fetch(`${API_URL}/search/availability/${zipValue}`);
                            if (res.status === 404) {
                                return;
                            }
                            const data = await res.json();

                            if (!data.deliveryLocation || !data.deliveryLocation.name || !data.deliveryLocation.location_id) {
                                return;
                            }

                            FulfillmentState.set('selected_zip_code', zipValue);
                            sessionStorage.setItem(`zipCache-${zipValue}`, JSON.stringify({ data, timestamp: Date.now() }));
                        } catch (err) {
                            return;
                        }
                    }
                } 
            }
        }

        // Update cart attributes when switching between delivery/pickup tabs
        async function updateCartDeliveryAttributes(deliveryType) {
            try {
                // Update localStorage with delivery type first
                FulfillmentState.set('selected_delivery_type', deliveryType);
                
                // Set location-specific localStorage values based on delivery type
                if (deliveryType === 'pickup') {
                    const selectedPickupRadio = document.querySelector('input[name="pickup-location"]:checked');
                    if (selectedPickupRadio) {
                        const locationId = selectedPickupRadio.getAttribute('data-location-id');
                        const locationName = selectedPickupRadio.getAttribute('data-location-name');
                        const locationZip = selectedPickupRadio.getAttribute('data-location-zip');
                        
                        if (locationId) FulfillmentState.set('selected_location_id', locationId);
                        if (locationName) FulfillmentState.set('selected_location_name', locationName);
                        if (locationZip) FulfillmentState.set('selected_zip_code', locationZip);
                    }
                } else if (deliveryType === 'delivery') {
                    const zipInput = document.getElementById('zip');
                    if (zipInput && zipInput.value.trim()) {
                        FulfillmentState.set('selected_zip_code', zipInput.value.trim());
                    }
                    // Restore delivery location ID from zipCache (supports both { data } and raw payload formats)
                    const zipCacheKey = Object.keys(sessionStorage).find(k => k.startsWith('zipCache-'));
                    if (zipCacheKey) {
                        try {
                            const parsed = JSON.parse(sessionStorage.getItem(zipCacheKey));
                            const payload = parsed?.data || parsed;
                            if (payload?.deliveryLocation) {
                                FulfillmentState.set('selected_location_id', payload.deliveryLocation.location_id);
                                FulfillmentState.set('selected_location_name', payload.deliveryLocation.name);
                            }
                        } catch (e) {}
                    }
                }
                
                // Do not sync cart while user is still editing inside modal.
                if (!isFulfillmentDraftMode()) {
                    await syncAllAttributesToCart();
                }
                
            } catch (error) {
                console.error('Failed to update cart attributes:', error);
            }
        }

        // Cart watcher
        if (!window.cartWatcher) {
            if (typeof CartWatcher === 'function') {
                // Creating new CartWatcher instance and attaching to window
                window.cartWatcher = new CartWatcher();
                window.cartWatcher.init();
            } else {
                console.warn('Delivery modal: CartWatcher is not available; cart change monitoring disabled.');
            }
        } else {
            // Using existing CartWatcher instance from window
        }
        const myCartWatcher = window.cartWatcher || null;
        window.addEventListener("cart_changed", async (e) => {
            if (!myCartWatcher || typeof myCartWatcher.fetchCart !== 'function') {
                return;
            }
            
            // Check if cart is empty
            const cart = await myCartWatcher.fetchCart();
            if (cart.item_count === 0) { 
                // clearCartAttributes();
            }
        });

        async function clearCartAttributes() {
            try {
                if (!myCartWatcher || typeof myCartWatcher.fetchCart !== 'function') {
                    return;
                }
                const cart = await myCartWatcher.fetchCart();

                // Remove all localStorage keys that start with 'selected_' and other relevant keys
                Object.keys(localStorage).forEach(key => {
                    if (key.startsWith('selected_')) {
                        localStorage.removeItem(key);
                    }
                    if(key.startsWith('location_price_list')) {
                        localStorage.removeItem(key);
                    }
                    if(key.startsWith('location_catalog_json')) {
                        localStorage.removeItem(key);
                    }
                    if(key.startsWith('rechargeSidebarCart')) {
                        localStorage.removeItem(key);
                    }
                    if(key.startsWith('selectedSubscriptionPlan')) {
                        localStorage.removeItem(key);
                    }
                });

                // Remove the generated delivery summary header bar
                const summaryHeader = document.querySelector('.delivery-summary-header');
                if (summaryHeader) {
                    summaryHeader.remove();
                }

                // Define all possible cart attributes that need to be cleared
                const attributesToClear = {
                    "_zipCode": "",
                    "_selectedFulfillmentDate": "",
                    "_selectedFulfillmentTime": "",
                    "_timeZone": "",
                    "Fulfillment Type": "",
                    "Fulfillment Date": "",
                    "LocationID": "",
                    "Delivery Status": "",
                    "Order Error": ""
                };


                const updateRes = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: attributesToClear }),
                });

                if (!updateRes.ok) {
                    const errorBody = await readErrorResponseBody(updateRes);
                    throw new Error(`Failed to clear cart attributes (${updateRes.status}): ${errorBody || 'empty response body'}`);
                }

                const updatedCart = await updateRes.json();

                lastSyncedFulfillmentSignature = null;

                if (window.LocationCatalogPricing) window.LocationCatalogPricing.refresh();
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clear-fulfillment', cartData: updatedCart });
                }
            } catch (err) {
                console.error('Failed to clear cart attributes:', err);
            }
        }

        async function openDeliveryModal(productVariantId) {
            // Opening delivery modal for variant
            
            // Check inventory before opening modal if inventory validator is available
            if (window.inventoryValidator && productVariantId) {
                try {
                    const checkResult = await window.inventoryValidator.canAddToCart(productVariantId, 1);

                    if (!checkResult.canAdd) {
                        if (checkResult.reason === 'inventory_prefetch_pending' && typeof window.inventoryValidator.showInventoryLoadingWarning === 'function') {
                            window.inventoryValidator.showInventoryLoadingWarning();
                        } else {
                            window.inventoryValidator.showInventoryWarning(productVariantId, checkResult);
                        }
                        return false;
                    }
                } catch (error) {
                    console.error('Error checking inventory:', error);
                }
            }

            // Inventory validator not available, no variant ID, or check passed
            return proceedWithOpeningModal(productVariantId);
        }
        window.openDeliveryModal = openDeliveryModal;

        async function proceedWithOpeningModal(productVariantId) {
            FulfillmentState._modalCancelled = false;
            FulfillmentState.snapshot();
            deliveryOptionManuallyChosen = false;
            
            // Show the modal first
            document.getElementById('delivery-modal')?.classList.remove('hidden');
            
            document.getElementById('delivery-step-two')?.classList.remove('hidden');
            document.querySelector('.delivery-modal-inner-wrapper')?.classList.add('options-view');
            
            // Prefill zip code from localStorage or customer data
            const zipInput = document.getElementById('zip');
            if (zipInput) {
                zipInput.classList.remove('error');
            }
            hideZipError();
            let zipCode = localStorage.getItem('selected_zip_code');
            
            // Auto-load customer ZIP if logged in and no existing ZIP
            if (!zipCode && window.customerData && window.customerData.isLoggedIn && window.customerData.zip) {
                zipCode = window.customerData.zip;
            }

            // Fall back to cached ZIP before using default
            if (!zipCode) {
                const zipMatch = Object.keys(sessionStorage).find((key) => key.startsWith('zipCache-'));
                zipCode = zipMatch ? zipMatch.replace('zipCache-', '') : null;
            }

            // Ensure ZIP always starts with a valid default for first-time users
            if (!zipCode) {
                zipCode = DEFAULT_DELIVERY_ZIP_CODE;
            }
            
            if (zipCode && zipInput) {
                zipInput.value = zipCode;
                
                // Check if we have cached data
                const cachedData = getCachedZipData(zipCode);
                if (cachedData) {
                    await processZipApiResponse(cachedData, zipCode);
                    setTimeout(() => {
                        updateBrowseButtonState();
                    }, 100);
                } else {
                    // If no cached data but we have zip, trigger auto-load
                    if (/^\d{5}$/.test(zipCode)) {
                        autoLoadZipOptions(zipCode);
                    }
                }
            }
            
            const locationId = localStorage.getItem('selected_location_id');
            const locationName = localStorage.getItem('selected_location_name');
            const priceElement = document.querySelector(`#price-${productVariantId}`);
            const isPriceUpdated = priceElement?.getAttribute('data-price-updated') === 'true';

            // Fallback: show fresh modal
            document.getElementById('delivery-modal')?.classList.remove('hidden');
            document.getElementById('delivery-step-two')?.classList.remove('hidden');
            document.querySelector('.delivery-modal-inner-wrapper')?.classList.add('options-view');
            
            // Store original form values and update button state
            setTimeout(() => {
                storeOriginalFormValues();
                updateBrowseButtonState();
            }, 100);
            return true;
        }

        async function clearCartFulfillmentAttributesOnRestore() {
            try {
                const fc = window.FulfillmentConstants || {};
                const selectedZipCode = localStorage.getItem(fc.ZIP_CODE || "selected_zip_code") || "";
                const selectedFulfillmentDate = localStorage.getItem(fc.DATE || "selected_fulfillment_date") || "";
                const selectedDeliveryType = localStorage.getItem(fc.DELIVERY_TYPE || "selected_delivery_type") || "";
                const selectedLocationId = localStorage.getItem(fc.LOCATION_ID || "selected_location_id") || "";
                const selectedTime = localStorage.getItem(fc.TIME || "selected_fulfillment_time") || "";
                const hasCommittedFulfillment =
                    !!selectedZipCode &&
                    !!selectedFulfillmentDate &&
                    !!selectedDeliveryType &&
                    !!selectedLocationId &&
                    (selectedDeliveryType !== 'delivery' || !!selectedTime);
                if (hasCommittedFulfillment && typeof syncAllAttributesToCart === 'function') {
                    await syncAllAttributesToCart({ force: true });
                    return;
                }

                const cartRes = await fetch('/cart.js');
                const cart = await cartRes.json();
                const attrs = cart.attributes || {};
                const keys = ['_selectedFulfillmentDate', 'Fulfillment Date', '_selectedFulfillmentTime', 'Order Error'];
                if (!keys.some(function(k) { return attrs[k]; })) return;
                const toClear = {};
                keys.forEach(function(k) { toClear[k] = ''; });
                await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: toClear }) });

                lastSyncedFulfillmentSignature = null;
            } catch (e) {}
        }
        window.clearCartFulfillmentAttributesOnRestore = clearCartFulfillmentAttributesOnRestore;

        let syncAllAttributesInFlight = null;
        let lastSyncedFulfillmentSignature = null;
        let syncAllAttributesDirty = false;

        // Sync all fulfillment attributes from localStorage to cart in one atomic call
        async function syncAllAttributesToCart(opts = {}) {
            const force = opts.force === true;
            if (!force && isFulfillmentDraftMode()) {
                return false;
            }

            // Mark that local fulfillment attributes may have changed
            syncAllAttributesDirty = true;

            // If a sync is already in flight, reuse its promise and let the dirty flag
            // schedule a single follow-up sync when it completes.
            if (syncAllAttributesInFlight) {
                return syncAllAttributesInFlight;
            }

            const runSyncOnce = async () => {
                const fc = window.FulfillmentConstants || {};
                const selectedZipCode = localStorage.getItem(fc.ZIP_CODE || "selected_zip_code") || "";
                const selectedFulfillmentDate = localStorage.getItem(fc.DATE || "selected_fulfillment_date") || "";
                const selectedTimeZone = localStorage.getItem(fc.TIME_ZONE || "selected_time_zone") || "America/Los_Angeles";
                const selectedDeliveryType = localStorage.getItem(fc.DELIVERY_TYPE || "selected_delivery_type") || "";
                const selectedLocationId = localStorage.getItem(fc.LOCATION_ID || "selected_location_id") || "";
                const selectedLocationName = localStorage.getItem(fc.LOCATION_NAME || "selected_location_name") || "";
                const selectedTime = localStorage.getItem(fc.TIME || "selected_fulfillment_time") || "";

                // All critical fulfillment attributes must be present before cart sync
                if (!selectedZipCode || !selectedFulfillmentDate || !selectedLocationId || !selectedDeliveryType) {
                    return false;
                }

                const attributes = {
                    "_zipCode": selectedZipCode,
                    "_selectedFulfillmentDate": selectedFulfillmentDate,
                    "_timeZone": selectedTimeZone,
                    "Fulfillment Type": selectedDeliveryType,
                    "LocationID": selectedLocationId,
                    "_locationName": selectedLocationName,
                    "_selectedFulfillmentTime": "",
                    "Fulfillment Date": "",
                };

                // Build Fulfillment Date ISO
                if (selectedDeliveryType === 'delivery' && selectedFulfillmentDate && selectedTime) {
                    // Delivery: use user-selected time
                    attributes["_selectedFulfillmentTime"] = selectedTime;
                    const isoDateTime = getLocalISOFromDateAndTime(selectedFulfillmentDate, selectedTime, selectedTimeZone);
                    if (isoDateTime) {
                        attributes["Fulfillment Date"] = isoDateTime;
                    }
                } else if (selectedDeliveryType === 'pickup' && selectedFulfillmentDate) {
                    // Pickup: only date matters; keep time fixed at midnight.
                    const pickupTimeStr = getPickupMidnightTime();
                    attributes["_selectedFulfillmentTime"] = pickupTimeStr;
                    const isoDateTime = getLocalISOFromDateAndTime(selectedFulfillmentDate, pickupTimeStr, selectedTimeZone);
                    if (!isoDateTime) {
                        return false;
                    }
                    attributes["Fulfillment Date"] = isoDateTime;
                }

                const requestSignature = JSON.stringify(attributes);
                if (!force && requestSignature === lastSyncedFulfillmentSignature) {
                    return true;
                }

                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes }),
                });
                if (!response.ok) {
                    throw new Error(`/cart/update.js failed (${response.status})`);
                }

                const contentType = response.headers.get('content-type') || '';
                if (contentType.indexOf('application/json') !== -1) {
                    await response.json();
                }

                lastSyncedFulfillmentSignature = requestSignature;
                return true;
            };

            syncAllAttributesDirty = false;

            syncAllAttributesInFlight = (async () => {
                const MAX_SYNC_ITERATIONS = 10;
                try {
                    let result = await runSyncOnce();
                    let iterations = 1;

                    // Drain queued changes: run until no new dirty flag is set (safety cap to avoid infinite loops)
                    while (syncAllAttributesDirty && iterations < MAX_SYNC_ITERATIONS) {
                        syncAllAttributesDirty = false;
                        result = await runSyncOnce();
                        iterations++;
                    }

                    return result;
                } catch (error) {
                    console.error('syncAllAttributesToCart failed:', error);
                    return false;
                } finally {
                    syncAllAttributesInFlight = null;
                }
            })();

            return syncAllAttributesInFlight;
        }

        function getPickupMidnightTime() {
            return '12:00 AM';
        }

        // Function to update cart count in header
        async function updateCartCountFromDeliveryModal() {
            await fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    // Try different selectors that might contain the cart count
                    const cartCountSelectors = [
                        '.cart-count-bubble',
                        '.cart-count',
                        '#cart-icon-bubble',
                        '.header__cart-count',
                        '[data-cart-count]',
                        '.site-header__cart-indicator'
                    ];

                    cartCountSelectors.forEach(selector => {
                        const elements = document.querySelectorAll(selector);
                        if (elements.length > 0) {
                            elements.forEach(element => {
                                // If the element has a data attribute for the count
                                if (element.hasAttribute('data-cart-count')) {
                                    element.setAttribute('data-cart-count', cart.item_count);
                                }

                                // Update the text content if it's just a number
                                if (/^\d+$/.test(element.textContent.trim())) {
                                    element.textContent = cart.item_count;
                                } else {
                                    // Look for a child element that might contain just the number
                                    const countElement = element.querySelector('span');
                                    if (countElement && /^\d+$/.test(countElement.textContent.trim())) {
                                        countElement.textContent = cart.item_count;
                                    }
                                }
                            });
                        }
                    });

                    // Dispatch a custom event for any custom cart implementations
                    document.dispatchEvent(new CustomEvent('cart:updated', {
                        bubbles: true,
                        detail: { cart: cart }
                    }));
                })
                .catch(error => {});
        }

        function forceOpenCartDrawer() {
            // Get all cart-drawer elements
            const allCartDrawers = document.querySelectorAll('cart-drawer');

            // Filter to only top-level (direct child of <body> or main container)
            const topLevelDrawer = Array.from(allCartDrawers).find((el) => {
                return el.parentElement === document.body || el.closest('body > *') === el;
            });

            if (!topLevelDrawer) {
                return;
            }

            // Ensure drawer is visible and active
            if (!topLevelDrawer.classList.contains('active')) {
                topLevelDrawer.classList.add('active');
            }
        }


        function closeDeliveryModal(opts) {
            opts = opts || {};
            const skipRestore = opts.skipRestore === true;
            const zipInput = document.getElementById('zip');

            if (window.zipInputTimer) {
                clearTimeout(window.zipInputTimer);
                window.zipInputTimer = null;
            }
            latestZipRequestId += 1;
            lastZipRequestValue = '';
            lastZipRequestAt = 0;
            hideZipError();
            if (zipInput) {
                zipInput.classList.remove('error');
            }

            if (!skipRestore) {
                FulfillmentState._modalCancelled = true;
                FulfillmentState.restore();
            }
            document.getElementById('delivery-modal')?.classList.add('hidden');
            const locationId = FulfillmentState.get('selected_location_id');
            if (!locationId) {
                clearCartFulfillmentAttributes();
            }
            if (!opts.skipRender) {
                const locationName = FulfillmentState.get('selected_location_name');
                if (locationName && typeof renderDeliverySummaryBar === 'function') {
                    renderDeliverySummaryBar(locationName);
                }
            }
        }

        async function clearCartFulfillmentAttributes() {
            try {
                const cartRes = await fetch('/cart.js');
                const cart = await cartRes.json();
                const attrs = cart.attributes || {};
                if (Object.keys(attrs).length === 0) return;
                const toNull = {};
                const fulfillmentKeys = ['_zipCode', '_selectedFulfillmentDate', '_timeZone', 'Fulfillment Type',
                    'LocationID', '_locationName', 'Fulfillment Date', '_selectedFulfillmentTime'];
                for (const k of Object.keys(attrs)) {
                    if (fulfillmentKeys.includes(k)) toNull[k] = '';
                }
                if (Object.keys(toNull).length === 0) return;
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: toNull })
                });
            } catch (e) {}
        }
        
        // Make closeDeliveryModal globally accessible for onclick handlers
        window.closeDeliveryModal = closeDeliveryModal;

        // Debounce timer for zip input (guard against redeclaration)
        if (typeof window.zipInputTimer === 'undefined') {
            window.zipInputTimer = null;
        }
        
        function handleZipInput(input) {
            const zipValue = input.value.trim();
            const loadingIndicator = document.getElementById('zip-loading');
            
            // Clear any existing timer
            if (window.zipInputTimer) {
                clearTimeout(window.zipInputTimer);
                window.zipInputTimer = null;
            }
            
            // Hide error when user is typing
            hideZipError();
            input.classList.remove('error');
            
            if (!/^\d{5}$/.test(zipValue)) {
                if (loadingIndicator) {
                    loadingIndicator.classList.add('hidden');
                }
                return;
            }
            
            if (loadingIndicator) {
                loadingIndicator.classList.remove('hidden');
            }
            
            // Debounce API call by 500ms
            window.zipInputTimer = setTimeout(async () => {
                await autoLoadZipOptions(zipValue);
                
                if (loadingIndicator) {
                    loadingIndicator.classList.add('hidden');
                }
                window.zipInputTimer = null;
            }, 500);
        }
        
        async function autoLoadZipOptions(zipValue) {
            const zipInput = document.getElementById('zip');
            const now = Date.now();
            if (zipValue === lastZipRequestValue && (now - lastZipRequestAt) < 800) {
                return;
            }
            const requestId = ++latestZipRequestId;
            lastZipRequestValue = zipValue;
            lastZipRequestAt = now;
            
            try {
                // Temporarily disable browse button during loading
                const browseButton = document.querySelector('.delivery-modal-continue-button');
                if (browseButton) {
                    browseButton.disabled = true;
                    browseButton.setAttribute('disabled', 'disabled');
                    browseButton.style.opacity = '0.6';
                    browseButton.style.cursor = 'wait';
                    browseButton.style.pointerEvents = 'none';
                }
                
                // Check if ZIP code is changing
                const previousZip = getFulfillmentStateValue('selected_zip_code');
                const isZipChanged = !!(previousZip && previousZip !== zipValue);
                if (isZipChanged) {
                    // ZIP changed — clear date, time, and location (all are zip-specific)
                    FulfillmentState.remove('selected_fulfillment_date');
                    FulfillmentState.remove('selected_fulfillment_time');
                    FulfillmentState.remove('selected_location_id');
                    FulfillmentState.remove('selected_location_name');
                }
                
                const res = await fetch(`${API_URL}/search/availability/${zipValue}`);
                if (res.status === 404) {
                    if (zipInput) {
                        zipInput.classList.add('error');
                        showZipError('Zip code is not deliverable. Please enter a different zip code');
                    }
                    // Re-enable button after error
                    if (browseButton) {
                        browseButton.disabled = false;
                        browseButton.removeAttribute('disabled');
                        browseButton.style.opacity = '';
                        browseButton.style.cursor = '';
                        browseButton.style.pointerEvents = '';
                    }
                    return;
                }
                
                const data = await res.json();
                if (requestId !== latestZipRequestId) {
                    return;
                }
                
                if (!data.deliveryLocation || !data.deliveryLocation.name || !data.deliveryLocation.location_id) {
                    if (zipInput) {
                        zipInput.classList.add('error');
                        showZipError('Zip code is not deliverable. Please enter a different zip code');
                    }
                    // Re-enable button after error
                    if (browseButton) {
                        browseButton.disabled = false;
                        browseButton.removeAttribute('disabled');
                        browseButton.style.opacity = '';
                        browseButton.style.cursor = '';
                        browseButton.style.pointerEvents = '';
                    }
                    return;
                }
                
                if (FulfillmentState._modalCancelled) return;

                await processZipApiResponse(data, zipValue, {
                    persist: true,
                    preferEarliestTime: isZipChanged
                });

                if (data.deliveryLocation?.location_id && data.deliveryLocation?.name) {
                    FulfillmentState.set('selected_location_id', String(data.deliveryLocation.location_id));
                    FulfillmentState.set('selected_location_name', data.deliveryLocation.name);
                    /* Catalog fetch deferred until user commits (Browse Menu) — avoids wasteful API calls before confirmation */
                }
                FulfillmentState.set('selected_zip_code', zipValue);

                Object.keys(sessionStorage).forEach((key) => {
                    if (key.startsWith('zipCache-')) {
                        sessionStorage.removeItem(key);
                    }
                });
                sessionStorage.setItem(`zipCache-${zipValue}`, JSON.stringify({ data, timestamp: Date.now() }));
                
                // Re-enable button and update state after successful load
                if (browseButton) {
                    updateBrowseButtonState();
                }
                
            } catch (err) {
                if (requestId !== latestZipRequestId) {
                    return;
                }
                if (zipInput) {
                    zipInput.classList.add('error');
                    showZipError('Unable to verify zip code. Please try again.');
                }
                // Re-enable button after error
                const browseButton = document.querySelector('.delivery-modal-continue-button');
                if (browseButton) {
                    browseButton.disabled = false;
                    browseButton.removeAttribute('disabled');
                    browseButton.style.opacity = '';
                    browseButton.style.cursor = '';
                    browseButton.style.pointerEvents = '';
                }
            }
        }

        function handleZipFocus() {
            // Remove error state when user focuses on the input
            document.getElementById('zip').classList.remove('error');
            hideZipError();
        }

        async function handleZipBlur(input) {
            if (!input.value.trim()) {
                input.classList.add('error');
                showZipError('Please enter a valid zip code');
                return;
            }
            const zipValue = input.value.trim();
            if (!/^\d{5}$/.test(zipValue)) {
                input.classList.add('error');
                showZipError('Only US 5-digit ZIP codes are allowed');
                return;
            }

            const currentZip = localStorage.getItem('selected_zip_code');
            if (currentZip === zipValue) return;
            if (zipValue === lastZipRequestValue && (Date.now() - lastZipRequestAt) < 1200) return;

            // Cancel any pending debounced fetch from handleZipInput
            if (window.zipInputTimer) {
                clearTimeout(window.zipInputTimer);
                window.zipInputTimer = null;
            }

            await autoLoadZipOptions(zipValue);
        }
        // Inline input handlers rely on these globals.
        window.handleZipInput = handleZipInput;
        window.handleZipFocus = handleZipFocus;
        window.handleZipBlur = handleZipBlur;

        async function handleLocateMe() {
            const zipInput = document.getElementById('zip');
            const locateBtn = document.getElementById('locate-me-btn');
            const apiUrl = typeof API_URL !== 'undefined' && API_URL ? API_URL : (window.EveryTable?.api?.baseUrl || window.API_URL);

            if (!navigator.geolocation) {
                showZipError('Location is not supported by your browser. Please enter your zip code.');
                if (zipInput) zipInput.classList.add('error');
                return;
            }
            if (!apiUrl) {
                showZipError('Locate me is not available right now. Please enter your zip code.');
                if (zipInput) zipInput.classList.add('error');
                return;
            }

            hideZipError();
            if (zipInput) zipInput.classList.remove('error');
            const locateSpinner = locateBtn ? locateBtn.querySelector('.delivery-modal-locate-me-spinner') : null;
            if (locateBtn) {
                locateBtn.disabled = true;
                locateBtn.setAttribute('aria-busy', 'true');
                locateBtn.classList.add('loading');
            }
            if (locateSpinner) locateSpinner.classList.remove('hidden');
            try {
                const position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, {
                        enableHighAccuracy: true,
                        timeout: 15000,
                        maximumAge: 0
                    });
                });
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                const url = apiUrl.replace(/\/+$/, '') + '/geocode?lat=' + encodeURIComponent(lat) + '&lng=' + encodeURIComponent(lng);
                const res = await fetch(url);
                let data = null;
                try {
                    data = await res.json();
                } catch (e) {
                    data = null;
                }

                if (!res.ok || !data || !data.zip) {
                    showZipError('Sorry we are unable to locate you, please enter your zip code');
                    if (zipInput) zipInput.classList.add('error');
                    return;
                }

                if (data.countryCode && String(data.countryCode).toUpperCase() !== 'US') {
                    showZipError('Sorry, we only deliver to the United States');
                    if (zipInput) zipInput.classList.add('error');
                    return;
                }

                const zipFromApi = String(data.zip).trim();
                if (!zipFromApi) {
                    showZipError('Sorry we are unable to locate you, please enter your zip code');
                    if (zipInput) zipInput.classList.add('error');
                    return;
                }

                let zipValue = zipFromApi;
                const dashIndex = zipValue.indexOf('-'); // handle ZIP+4 like 90001-1234
                if (dashIndex !== -1) {
                    zipValue = zipValue.slice(0, dashIndex);
                }
                zipValue = zipValue.trim();
                const zipNumber = Number(zipValue);
              
                if (zipValue.length !== 5 || !Number.isFinite(zipNumber)) {
                    showZipError('Only 5-digit US ZIP codes are allowed');
                    if (zipInput) zipInput.classList.add('error');
                    return;
                }
                if (zipInput) {
                    zipInput.value = zipValue;
                    zipInput.classList.remove('error');
                }
                hideZipError();
                await autoLoadZipOptions(zipValue);
            } catch (err) {
                if (err && typeof err === 'object' && 'code' in err) {
                    const code = err.code;
                    if (code === 1) {
                        showZipError('Location permission denied. Please allow it from site settings. ');
                    } else if (code === 2) {
                        showZipError('Location unavailable. Please enter your zip code.');
                    } else if (code === 3) {
                        showZipError('Location request timed out. Please enter your zip code.');
                    } else {
                        showZipError('Could not get your location. Please enter your zip code.');
                    }
                } else {
                    showZipError('Could not get your location. Please enter your zip code.');
                }
                if (zipInput) zipInput.classList.add('error');
            } finally {
                if (locateSpinner) locateSpinner.classList.add('hidden');
                if (locateBtn) {
                    locateBtn.classList.remove('loading');
                    locateBtn.disabled = false;
                    locateBtn.removeAttribute('aria-busy');
                }
            }
        }
        window.handleLocateMe = handleLocateMe;

        async function proceedToOptions() {
            const zipInput = document.getElementById('zip');
            const zipValue = zipInput.value.trim();

            if (!zipValue) {
                zipInput.classList.add('error');
                showZipError('Please enter a valid zip code');
                return;
            }
            if (!/^\d{5}$/.test(zipValue)) {
                zipInput.classList.add('error');
                showZipError('Only 5-digit US ZIP codes are allowed');
                return;
            }
            
            // Check if ZIP code is changing
            const previousZip = getFulfillmentStateValue('selected_zip_code');
            if (previousZip && previousZip !== zipValue) {
                FulfillmentState.remove('selected_fulfillment_date');
                FulfillmentState.remove('selected_fulfillment_time');
                FulfillmentState.remove('selected_location_id');
                FulfillmentState.remove('selected_location_name');
            }
            
            removeAllZipCaches();
            showLoadingOverlay();
            try {
                const res = await fetch(`${API_URL}/search/availability/${zipValue}`);
                if (res.status === 404) {
                    hideLoadingOverlay();
                    // openUnavailableModal(); // email modal for store update disabled
                    // Show error message for invalid ZIP
                    const zipInput = document.getElementById('zip');
                    if (zipInput) {
                        zipInput.classList.add('error');
                        showZipError('Zip code is not deliverable. Please enter a different zip code');
                    }
                    return;
                }
                const data = await res.json();

                if (!data.deliveryLocation || !data.deliveryLocation.name || !data.deliveryLocation.location_id) {
                    hideLoadingOverlay();
                    // openUnavailableModal(); // email modal for store update disabled
                    // Show error message for invalid data
                    const zipInput = document.getElementById('zip');
                    if (zipInput) {
                        zipInput.classList.add('error');
                        showZipError('Zip code is not deliverable. Please enter a different zip code');
                    }
                    return;
                }

                await processZipApiResponse(data, zipValue, {
                    preferEarliestTime: !!(previousZip && previousZip !== zipValue)
                });
                FulfillmentState.set('selected_location_name', data.deliveryLocation.name);
                FulfillmentState.set('selected_location_id', data.deliveryLocation.location_id);
                Object.keys(sessionStorage).forEach((key) => {
                    if (key.startsWith('zipCache-')) {
                        sessionStorage.removeItem(key);
                    }
                });

                sessionStorage.setItem(`zipCache-${zipValue}`, JSON.stringify({ data, timestamp: Date.now() }));
                            FulfillmentState.set('selected_zip_code', zipValue);

            } catch (err) {
                console.error('Failed to fetch zip availability:', err);
                zipInput.classList.add('error');
                showZipError('Unable to verify zip code. Please try again.');
            } finally {
                hideLoadingOverlay();
            }
        }

        function removeAllZipCaches() {
            Object.keys(sessionStorage).forEach((key) => {
                if (key.startsWith('zipCache-')) {
                    sessionStorage.removeItem(key);
                }
            });
            FulfillmentState.remove("location_price_list");
            FulfillmentState.remove("selected_location_id");
            FulfillmentState.remove("selected_location_name");
        }


        function getCachedZipData(zip) {
            const cacheKey = `zipCache-${zip}`;
            try {
                const cached = sessionStorage.getItem(cacheKey);
                if (!cached) return null;

                const parsed = JSON.parse(cached);
                if (!parsed) return null;

                if (parsed.timestamp) {
                    const isExpired = Date.now() - parsed.timestamp > 30 * 60 * 1000;
                    if (isExpired) return null;
                }

                // Support both { data, timestamp } and raw cached payload shapes
                return parsed.data ? parsed.data : parsed;
            } catch (e) {
                return null;
            }
        }

        async function processZipApiResponse(data, zipCode, opts = {}) {
            const persist = opts.persist !== false;
            const preferEarliestTime = opts.preferEarliestTime === true;
            if (persist && zipCode) {
                FulfillmentState.set('selected_zip_code', zipCode);
            }

            persistDayHoursCache(zipCode, data);
            
            const hasDeliveryDays = Array.isArray(data.deliveryDays) && data.deliveryDays.length > 0;
            const hasDeliveryLocation = data.deliveryLocation && data.deliveryLocation.name;
            const hasPickupLocations = Array.isArray(data.pickupLocations) && data.pickupLocations.length > 0;
            const deliveryUnavailable = !hasDeliveryDays || !hasDeliveryLocation;
            const isDeliveryBlocked = deliveryUnavailable;
            const isFullyBlocked = !hasPickupLocations && deliveryUnavailable;

            // Hide or show delivery tab
            const deliveryTab = document.getElementById('delivery-tab');
            if (deliveryTab) {
                deliveryTab.style.display = isDeliveryBlocked ? 'none' : 'flex';
            }

            // 🔒 If both delivery & pickup are unavailable, show fallback modal and exit early
            if (isFullyBlocked) {
                closeDeliveryModal();
                // openUnavailableModal(); // email modal for store update disabled

                const deliverySummaryHeader = document.querySelector('.delivery-summary-header');
                if (isDeliveryBlocked && deliverySummaryHeader) {
                    deliverySummaryHeader.remove();
                }
                return;
            }

            if (hasPickupLocations) {
                renderPickupLocations(data.pickupLocations, opts);
                if (persist) preselectPreviousPickupLocation();
            }

            if (hasDeliveryDays) {
                await renderDeliveryDates(data.deliveryDays, { preferEarliestTime });
            }

            if (hasDeliveryLocation) {
                // Only set delivery location if user hasn't already selected a pickup location
                const currentDeliveryType = getFulfillmentStateValue('selected_delivery_type');
                const currentLocationId = getFulfillmentStateValue('selected_location_id');

                // If we're in pickup mode and have a selected location, don't override it
                if (persist && !(currentDeliveryType === 'pickup' && currentLocationId && currentLocationId !== data.deliveryLocation.location_id)) {
                    FulfillmentState.set('selected_location_name', data.deliveryLocation.name);
                    FulfillmentState.set('selected_location_id', data.deliveryLocation.location_id);
                }
            }

            if (persist && data.locationTimeZone) {
                FulfillmentState.set("selected_time_zone", data.locationTimeZone);
            }

            document.getElementById('delivery-step-two')?.classList.remove('hidden');
            document.querySelector('.delivery-modal-inner-wrapper')?.classList.add('options-view');

            // Show or hide delivery error
            const deliveryErrorEl = document.getElementById('delivery-error-message');
            deliveryErrorEl?.classList.toggle('hidden', !isDeliveryBlocked);

            // Hide delivery date & subscription UI if delivery is blocked
            document.getElementById('delivery-section')?.classList.toggle('hidden', isDeliveryBlocked);
            document.querySelector('.subscription-option')?.classList.toggle('hidden', isDeliveryBlocked);

            // Disable browse button if delivery is selected but unavailable
            const browseButton = document.querySelector('.delivery-modal-continue-button');
            if (browseButton) {
                const selected = getSelectedDeliveryOption();
                const shouldDisable = isDeliveryBlocked && selected === 'delivery';

                if (shouldDisable) {
                    browseButton.disabled = true;
                    browseButton.setAttribute('disabled', 'disabled');
                    browseButton.classList.add('disabled');
                    browseButton.style.opacity = '0.6';
                    browseButton.style.cursor = 'not-allowed';
                    browseButton.style.pointerEvents = 'none';
                } else {
                    browseButton.disabled = false;
                    browseButton.removeAttribute('disabled');
                    browseButton.classList.remove('disabled');
                    browseButton.style.opacity = '';
                    browseButton.style.cursor = '';
                    browseButton.style.pointerEvents = '';
                }
            }

            // Determine default selection based on localStorage if valid
            let defaultOption = getFulfillmentStateValue('selected_delivery_type');
            if (defaultOption !== 'pickup' && defaultOption !== 'delivery') {
                defaultOption = isDeliveryBlocked ? 'pickup' : 'delivery';
            }

            if (deliveryOptionManuallyChosen) {
                const currentOption = getFulfillmentStateValue('selected_delivery_type');
                if (currentOption === 'pickup' || currentOption === 'delivery') {
                    defaultOption = currentOption;
                }
            }

            if (isDeliveryBlocked && defaultOption === 'delivery') {
                defaultOption = 'pickup';
            }

            await selectDeliveryOption(defaultOption, Object.assign({}, opts, { autoSelect: true }));
        }

        function preselectPreviousPickupLocation() {
            const prevLocationId = getFulfillmentStateValue('selected_location_id');
            if (!prevLocationId) return;

            const radios = document.querySelectorAll('input[name="pickup-location"]');
            for (const radio of radios) {
                if (radio.dataset.locationId === prevLocationId) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change')); // Trigger any change handlers
                    break;
                }
            }
        }

        function getSelectedDeliveryOption() {
            const selectedOption = getFulfillmentStateValue('selected_delivery_type');
            return selectedOption || 'pickup';
        }

        function clearOldZipCaches(maxAgeMs = 6 * 60 * 60 * 1000) { // 6 hours
            const now = Date.now();
            for (let i = sessionStorage.length - 1; i >= 0; i--) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith('zipCache-')) {
                    try {
                        const cached = JSON.parse(sessionStorage.getItem(key));
                        if (!cached.timestamp || now - cached.timestamp > maxAgeMs) {
                            sessionStorage.removeItem(key);
                        }
                    } catch (e) {
                        sessionStorage.removeItem(key);
                    }
                }
            }
        }


        function showLoadingOverlay() {
            document.getElementById('modal-loading-overlay').classList.remove('hidden');
        }

        function hideLoadingOverlay() {
            document.getElementById('modal-loading-overlay').classList.add('hidden');
        }

        // Helper function to format delivery date for summary bar
        function formatDeliveryDateForSummary(dateStr) {
            if (!dateStr) return '';
            
            // Get today and tomorrow in STORE timezone
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            const now = new Date();
            
            let todayStr, tomorrowStr;
            try {
                const dateFormatter = new Intl.DateTimeFormat("en-CA", {
                    timeZone: timeZone,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                
                todayStr = dateFormatter.format(now).replace(/\//g, "-");
                
                const tomorrowDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                tomorrowStr = dateFormatter.format(tomorrowDate).replace(/\//g, "-");
            } catch (err) {
                console.error('Error getting dates in store timezone:', err);
                // Fallback to browser timezone
                todayStr = now.getFullYear() + '-' + 
                           String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                           String(now.getDate()).padStart(2, '0');
                const tomorrow = new Date(now);
            tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrowStr = tomorrow.getFullYear() + '-' + 
                              String(tomorrow.getMonth() + 1).padStart(2, '0') + '-' + 
                              String(tomorrow.getDate()).padStart(2, '0');
            }
            
            if (dateStr === todayStr) {
                return 'Today';
            } else if (dateStr === tomorrowStr) {
                return 'Tomorrow';
            } else {
                // Format as "Tuesday, January 9th, 2025"
                const [year, month, day] = dateStr.split('-');
                const date = new Date(`${year}-${month}-${day}T00:00:00`);
                const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
                const monthName = date.toLocaleDateString('en-US', { month: 'long' });
                const dayNum = parseInt(day, 10);
                
                // Add ordinal suffix (1st, 2nd, 3rd, etc.)
                const getOrdinalSuffix = (num) => {
                    if (num > 3 && num < 21) return 'th';
                    switch (num % 10) {
                        case 1: return 'st';
                        case 2: return 'nd';
                        case 3: return 'rd';
                        default: return 'th';
                    }
                };
                
                return `${weekday}, ${monthName} ${dayNum}${getOrdinalSuffix(dayNum)}, ${year}`;
            }
        }

        // Restore time from cart attributes if not in localStorage
        async function restoreTimeFromCart(expectedDate) {
            const savedTime = localStorage.getItem('selected_fulfillment_time');
            if (savedTime) {
                return savedTime; // Already have it
            }
            
            try {
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();
                const attrs = cart.attributes || {};
                
                // Prefer explicit _selectedFulfillmentTime (persisted display format)
                const explicitTime = attrs['_selectedFulfillmentTime'];
                if (explicitTime && typeof explicitTime === 'string' && explicitTime.trim()) {
                    const fulfillmentDate = attrs['Fulfillment Date'];
                    const cartDatePart = fulfillmentDate ? (String(fulfillmentDate).includes('T') ? String(fulfillmentDate).split('T')[0] : String(fulfillmentDate).split(/\s+/)[0] || '') : '';
                    if (expectedDate && cartDatePart && cartDatePart !== expectedDate) {
                        // time's cart date does not match expected date; do not use it
                    } else {
                        const normalizedExplicitTime = explicitTime.trim();
                        if (!expectedDate || !isDateTimePast(expectedDate, normalizedExplicitTime)) {
                            FulfillmentState.set('selected_fulfillment_time', normalizedExplicitTime);
                            return normalizedExplicitTime;
                        }
                    }
                }
                
                const fulfillmentDate = attrs['Fulfillment Date'];
                if (fulfillmentDate) {
                    const cartDatePart = String(fulfillmentDate).includes('T') ? String(fulfillmentDate).split('T')[0] : String(fulfillmentDate).split(/\s+/)[0] || '';
                    if (expectedDate && cartDatePart && cartDatePart !== expectedDate) {
                        return '';
                    }
                    // Parse ISO datetime to extract time (e.g., "2025-11-17T14:30:00" -> "2:30 PM")
                    const timeMatch = fulfillmentDate.match(/T(\d{2}):(\d{2}):/);
                    if (timeMatch) {
                        const hours = parseInt(timeMatch[1]);
                        const minutes = parseInt(timeMatch[2]);
                        
                        // Convert to 12-hour format
                        const period = hours >= 12 ? 'PM' : 'AM';
                        const displayHours = hours === 0 ? 12 : (hours > 12 ? hours - 12 : hours);
                        const displayMinutes = String(minutes).padStart(2, '0');
                        const timeStr = `${displayHours}:${displayMinutes} ${period}`;
                        
                        if (expectedDate && isDateTimePast(expectedDate, timeStr)) {
                            return '';
                        }
                        
                        // Save to localStorage for future use
                        FulfillmentState.set('selected_fulfillment_time', timeStr);
                        return timeStr;
                    }
                }
            } catch (err) {
                console.error('Failed to restore time from cart:', err);
            }
            
            return '';
        }
        
        let renderSummaryBarTimer = null;
        let renderSummaryBarInProgress = false;
        async function renderDeliverySummaryBar(locationName) {
            if (window.FulfillmentState && typeof window.FulfillmentState.isDraftMode === 'function' && window.FulfillmentState.isDraftMode()) return;
            if (!locationName) return;
            if ((window.location.pathname || '').indexOf('/tools/recurring') !== -1) return;
            if (renderSummaryBarInProgress) return;

            if (renderSummaryBarTimer) clearTimeout(renderSummaryBarTimer);
            renderSummaryBarTimer = setTimeout(async function doRender() {
                renderSummaryBarTimer = null;
                renderSummaryBarInProgress = true;
                try {
                const existingBars = document.querySelectorAll('.delivery-summary-header');
                existingBars.forEach(bar => bar.remove());

            const zipCode = localStorage.getItem('selected_zip_code') || '';
            const deliveryType = getSelectedDeliveryOption() || 'delivery';
            const selectedDate = localStorage.getItem('selected_fulfillment_date') || '';
            
            if (!zipCode) {
                return;
            }
            
            // Try localStorage first, then cart attributes
            let selectedTime = localStorage.getItem('selected_fulfillment_time') || '';
            if (!selectedTime && deliveryType === 'delivery') {
                selectedTime = await restoreTimeFromCart(selectedDate);
            }
            
            const title = deliveryType === 'pickup' ? 'Pickup' : 'Partner Delivery';
            
            // Format the date for display
            const formattedDate = formatDeliveryDateForSummary(selectedDate);
            
            let destinationLine;
            if (deliveryType === 'pickup') {
                destinationLine = `Pickup at ${zipCode}`;
                    } else {
                destinationLine = `Delivery to ${zipCode}`;
                    }
            
                if (formattedDate) {
                    if (formattedDate === 'Today' || formattedDate === 'Tomorrow') {
                    destinationLine += ` ${formattedDate}`;
                    } else {
                    destinationLine += ` on ${formattedDate}`;
                }
            }
            
            const timeSegment = deliveryType === 'delivery' && selectedTime
                ? `at ${selectedTime}`
                : '';

            const pathname = window.location.pathname;
            const isCollectionOrProduct = pathname.includes('/collections/') || 
                                         pathname.includes('/products/') ||
                                         pathname.includes('/pages/subscriptions') ||
                                         pathname.includes('/pages/subscription') ||
                                         pathname.includes('/pages/subscribe') ||
                                         pathname === '/pages/subscriptions' ||
                                         pathname === '/pages/subscription' ||
                                         pathname === '/pages/subscribe';
            
            const displayStyle = isCollectionOrProduct ? '' : 'style="display: none;"';
            
            const summaryHTML = `
                <div class="delivery-summary-header" ${displayStyle}>
                  <div class="delivery-summary-bar page-width">
                    <div class="delivery-summary-location">
                      <div class="summary-text">
                        <div class="summary-heading-row">
                          <span class="summary-heading">${title}:</span>
                          <span class="summary-location-line">${locationName}</span>
                        </div>
                        <div class="summary-meta">
                          <span class="summary-destination">${destinationLine}</span>
                          ${timeSegment ? `<span class="summary-time">${timeSegment}</span>` : ''}
                        </div>
                      </div>
                      <button class="edit-location-btn" onclick="openDeliveryModalFromHeader()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#00464b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 20h9"></path>
                          <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                        </svg>
                        Edit
                      </button>
                    </div>
                  </div>
                </div>
              `;

            const header = document.querySelector('header') || 
                           document.querySelector('.header') || 
                           document.querySelector('#shopify-section-header') ||
                           document.querySelector('.section-header') ||
                           document.querySelector('[data-section-id="header"]');
                           
            if (header) {
                const wrapper = document.createElement('div');
                wrapper.innerHTML = summaryHTML;
                header.insertAdjacentElement('afterend', wrapper.firstElementChild);
            } else {
                const main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
                if (main) {
                     const wrapper = document.createElement('div');
                     wrapper.innerHTML = summaryHTML;
                     main.prepend(wrapper.firstElementChild);
                }
            }
                } finally {
                    renderSummaryBarInProgress = false;
                }
            }, 50);
        }



        function isDatePastClosingTime(dayData) {
            // Get store timezone
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            
            const now = new Date();
            
            // Get current date in STORE timezone
            const todayInStoreStr = new Intl.DateTimeFormat("en-CA", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
                .format(now)
                .replace(/\//g, "-");
            
            // Only check for today's date
            if (dayData.date !== todayInStoreStr) {
                return false;
            }
            
            // If no close time provided, can't determine
            if (!dayData.close) {
                return false;
            }
            
            try {
                const closeTimeStr = dayData.close;
                
                // Parse time like "7:30 AM" or "7:30 PM"
                const timeMatch = closeTimeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
                if (!timeMatch) {
                    return false;
                }
                
                let hours = parseInt(timeMatch[1], 10);
                const minutes = parseInt(timeMatch[2], 10);
                const period = timeMatch[3].toUpperCase();
                
                // Convert to 24-hour format
                if (period === 'PM' && hours !== 12) {
                    hours += 12;
                } else if (period === 'AM' && hours === 12) {
                    hours = 0;
                }
                
                const closeTimeMinutes = hours * 60 + minutes;
                
                // Get current time in STORE timezone
                let storeCurrentHour = 0;
                let storeCurrentMinute = 0;
                
                try {
                    const timeFormatter = new Intl.DateTimeFormat("en-US", {
                        timeZone,
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    });
                    
                    const timeParts = timeFormatter.formatToParts(now);
                    storeCurrentHour = parseInt(timeParts.find(p => p.type === 'hour')?.value || '0', 10);
                    storeCurrentMinute = parseInt(timeParts.find(p => p.type === 'minute')?.value || '0', 10);
                } catch (err) {
                    console.error('Error getting store current time in isDatePastClosingTime:', err);
                    // Fallback to browser time if timezone conversion fails
                    storeCurrentHour = now.getHours();
                    storeCurrentMinute = now.getMinutes();
                }
                
                const currentTimeMinutes = storeCurrentHour * 60 + storeCurrentMinute;
                
                // Check if current time is past closing time
                return currentTimeMinutes > closeTimeMinutes;
            } catch (error) {
                return false;
            }
        }

        // Module-global state for the delivery modal, declared with `var` (not `let`) on
        // purpose. These are read by functions (ensureFreshFulfillmentSelection, the calendar
        // renderers) that the Shopify CDN minifier hoists above this declaration; with `let`
        // the bindings sit in a temporal dead zone until this line runs, so a reader that
        // fires first throws a ReferenceError in Safari (e.g. the visibilitychange/pageshow
        // resume path). `var` hoists as undefined so they always resolve, matching the
        // existing `var` convention at the top of this block. See Sentry SHOPIFY-398.

        // Delivery / pickup days, for time slot generation and calendar rendering
        var currentDeliveryDays = [];
        var currentPickupDays = [];
        
        // Date change handler, to prevent duplicate listeners
        var dateChangeHandler = null;

        // Inline calendar state for delivery fulfillment date
        var deliveryCalendarMonthDate = null;
        var deliveryCalendarSelectedDate = null;
        var deliveryCalendarInitialized = false;

        // Inline calendar state for pickup fulfillment date
        var pickupCalendarMonthDate = null;
        var pickupCalendarSelectedDate = null;
        var pickupCalendarInitialized = false;

        // currentDeliveryDays/currentPickupDays reset to [] on every page load, but the
        // committed fulfillment selection persists in localStorage. Closing-time validation
        // in ensureFreshFulfillmentSelection therefore needs a persistent copy of the store
        // hours, or any checkout on a page where the modal never opened validates against
        // an empty array and fails open (order 6492916351033: same-day pickup placed at
        // 7:23 PM, past the 7 PM close). The cache is keyed by location id (pickup) or
        // zip (delivery) and refreshed on every availability lookup.
        function compactDayHours(days) {
            return days
                .filter(function(day) { return day && day.date; })
                .map(function(day) {
                    return { date: day.date, isClosed: !!day.isClosed, close: day.close || '' };
                });
        }

        function readDayHoursMap(storageKey) {
            try {
                const parsed = JSON.parse(localStorage.getItem(storageKey) || '{}');
                return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch (e) {
                return {};
            }
        }

        function persistDayHoursCache(zipCode, data) {
            try {
                if (zipCode && Array.isArray(data.deliveryDays)) {
                    let deliveryMap = readDayHoursMap('et_delivery_day_hours');
                    // Zips accumulate across sessions; keep the map from growing unbounded.
                    if (Object.keys(deliveryMap).length > 20) deliveryMap = {};
                    deliveryMap[String(zipCode)] = compactDayHours(data.deliveryDays);
                    localStorage.setItem('et_delivery_day_hours', JSON.stringify(deliveryMap));
                }
                if (Array.isArray(data.pickupLocations)) {
                    const pickupMap = readDayHoursMap('et_pickup_day_hours');
                    data.pickupLocations.forEach(function(loc) {
                        if (loc && loc.location_id && Array.isArray(loc.pickupDates)) {
                            pickupMap[String(loc.location_id)] = compactDayHours(loc.pickupDates);
                        }
                    });
                    localStorage.setItem('et_pickup_day_hours', JSON.stringify(pickupMap));
                }
            } catch (e) {
                // The hours cache is best-effort; never block the availability flow on it.
            }
        }

        function getCachedDayData(deliveryType, dateStr) {
            if (!dateStr) return null;
            try {
                const isPickup = deliveryType === 'pickup';
                const ownerKey = isPickup
                    ? (localStorage.getItem('selected_location_id') || '')
                    : (localStorage.getItem('selected_zip_code') || '');
                if (!ownerKey) return null;
                const map = readDayHoursMap(isPickup ? 'et_pickup_day_hours' : 'et_delivery_day_hours');
                const days = map[String(ownerKey)];
                if (!Array.isArray(days)) return null;
                return days.find(function(day) { return day && day.date === dateStr; }) || null;
            } catch (e) {
                return null;
            }
        }

        function getDeliveryCalendarRefs() {
            const calendar = document.getElementById('delivery-calendar');
            if (!calendar) return null;

            const monthLabel = document.getElementById('delivery-calendar-month');
            const grid = document.getElementById('delivery-calendar-grid');
            const prevButton = document.getElementById('delivery-calendar-prev');
            const nextButton = document.getElementById('delivery-calendar-next');

            if (!monthLabel || !grid || !prevButton || !nextButton) {
                return null;
            }

            return {
                calendar,
                monthLabel,
                grid,
                prevButton,
                nextButton
            };
        }

        function getPickupCalendarRefs() {
            const calendar = document.getElementById('pickup-calendar');
            if (!calendar) return null;

            const monthLabel = document.getElementById('pickup-calendar-month');
            const grid = document.getElementById('pickup-calendar-grid');
            const prevButton = document.getElementById('pickup-calendar-prev');
            const nextButton = document.getElementById('pickup-calendar-next');

            if (!monthLabel || !grid || !prevButton || !nextButton) {
                return null;
            }

            return {
                calendar,
                monthLabel,
                grid,
                prevButton,
                nextButton
            };
        }

        function parseSimpleIsoDateForCalendar(value) {
            if (!value) return null;
            const parts = String(value).split('-');
            if (parts.length !== 3) return null;
            const year = parseInt(parts[0], 10);
            const monthIndex = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[2], 10);
            if (!Number.isFinite(year) || !Number.isFinite(monthIndex) || !Number.isFinite(day)) {
                return null;
            }
            const date = new Date(year, monthIndex, day);
            if (date.getFullYear() !== year || date.getMonth() !== monthIndex || date.getDate() !== day) {
                return null;
            }
            return date;
        }

        function formatSimpleIsoDateForCalendar(date) {
            if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
                return '';
            }
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return year + '-' + month + '-' + day;
        }

        function getDeliveryCalendarBounds() {
            if (!Array.isArray(currentDeliveryDays) || currentDeliveryDays.length === 0) {
                return { min: null, max: null };
            }

            let min = null;
            let max = null;

            currentDeliveryDays.forEach(function(day) {
                if (!day || !day.date) return;
                const parsed = parseSimpleIsoDateForCalendar(day.date);
                if (!parsed) return;
                if (!min || parsed < min) min = parsed;
                if (!max || parsed > max) max = parsed;
            });

            return { min: min, max: max };
        }

        function getPickupCalendarBounds() {
            if (!Array.isArray(currentPickupDays) || currentPickupDays.length === 0) {
                return { min: null, max: null };
            }

            let min = null;
            let max = null;

            currentPickupDays.forEach(function(day) {
                if (!day || !day.date) return;
                const parsed = parseSimpleIsoDateForCalendar(day.date);
                if (!parsed) return;
                if (!min || parsed < min) min = parsed;
                if (!max || parsed > max) max = parsed;
            });

            return { min: min, max: max };
        }

        function ensureDeliveryCalendarInitialized() {
            const refs = getDeliveryCalendarRefs();
            if (!refs) return;

            if (!deliveryCalendarInitialized) {
                deliveryCalendarInitialized = true;

                refs.prevButton.addEventListener('click', function() {
                    const bounds = getDeliveryCalendarBounds();
                    if (!deliveryCalendarMonthDate) return;
                    const candidate = new Date(
                        deliveryCalendarMonthDate.getFullYear(),
                        deliveryCalendarMonthDate.getMonth() - 1,
                        1
                    );

                    if (bounds.min) {
                        const earliestMonth = new Date(bounds.min.getFullYear(), bounds.min.getMonth(), 1);
                        if (candidate < earliestMonth) {
                            return;
                        }
                    }

                    deliveryCalendarMonthDate = candidate;
                    renderDeliveryCalendarGrid();
                });

                refs.nextButton.addEventListener('click', function() {
                    const bounds = getDeliveryCalendarBounds();
                    if (!deliveryCalendarMonthDate) return;
                    const candidate = new Date(
                        deliveryCalendarMonthDate.getFullYear(),
                        deliveryCalendarMonthDate.getMonth() + 1,
                        1
                    );

                    if (bounds.max) {
                        const latestMonth = new Date(bounds.max.getFullYear(), bounds.max.getMonth(), 1);
                        if (candidate > latestMonth) {
                            return;
                        }
                    }

                    deliveryCalendarMonthDate = candidate;
                    renderDeliveryCalendarGrid();
                });

                refs.grid.addEventListener('click', function(event) {
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return;
                    const dayButton = target.closest('button[data-date]');
                    if (!(dayButton instanceof HTMLButtonElement) || dayButton.disabled) {
                        return;
                    }
                    const nextDate = dayButton.getAttribute('data-date');
                    if (!nextDate) return;

                    deliveryCalendarSelectedDate = nextDate;

                    const select = document.getElementById('fulfillment-date-delivery');
                    if (select) {
                        select.value = nextDate;
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    try {
                        const fc = window.FulfillmentConstants || {};
                        const dateKey = fc.DATE || 'selected_fulfillment_date';
                        if (window.FulfillmentState && typeof window.FulfillmentState.set === 'function') {
                            window.FulfillmentState.set(dateKey, nextDate);
                        } else {
                            localStorage.setItem(dateKey, nextDate);
                        }
                    } catch (error) {
                        console.warn('Unable to persist fulfillment date selection:', error);
                    }

                    dispatchCommittedFulfillmentDateChanged(nextDate);

                    renderDeliveryCalendarGrid();
                });
            }
        }

        function renderDeliveryCalendarGrid() {
            const refs = getDeliveryCalendarRefs();
            if (!refs) return;
            if (!Array.isArray(currentDeliveryDays) || currentDeliveryDays.length === 0) {
                refs.grid.innerHTML = '';
                refs.monthLabel.textContent = '';
                refs.prevButton.disabled = true;
                refs.nextButton.disabled = true;
                return;
            }

            const bounds = getDeliveryCalendarBounds();

            if (!deliveryCalendarMonthDate) {
                let initialDate = null;
                if (deliveryCalendarSelectedDate) {
                    initialDate = parseSimpleIsoDateForCalendar(deliveryCalendarSelectedDate);
                }
                if (!initialDate && bounds.min) {
                    initialDate = bounds.min;
                }
                if (!initialDate) {
                    initialDate = new Date();
                }
                deliveryCalendarMonthDate = new Date(
                    initialDate.getFullYear(),
                    initialDate.getMonth(),
                    1
                );
            }

            const monthStart = new Date(
                deliveryCalendarMonthDate.getFullYear(),
                deliveryCalendarMonthDate.getMonth(),
                1
            );

            // Update nav button disabled state based on bounds
            if (bounds.min) {
                const earliestMonth = new Date(bounds.min.getFullYear(), bounds.min.getMonth(), 1);
                const prevMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() - 1, 1);
                refs.prevButton.disabled = prevMonth < earliestMonth;
            } else {
                refs.prevButton.disabled = true;
            }

            if (bounds.max) {
                const latestMonth = new Date(bounds.max.getFullYear(), bounds.max.getMonth(), 1);
                const nextMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 1);
                refs.nextButton.disabled = nextMonth > latestMonth;
            } else {
                refs.nextButton.disabled = true;
            }

            refs.monthLabel.textContent = monthStart.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
            });

            const year = monthStart.getFullYear();
            const monthIndex = monthStart.getMonth();
            const firstWeekday = monthStart.getDay(); // 0 = Sunday
            const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

            refs.grid.innerHTML = '';

            for (let cellIndex = 0; cellIndex < 42; cellIndex += 1) {
                const dayNumber = cellIndex - firstWeekday + 1;
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'et-affinity-reschedule-calendar__day';

                if (dayNumber < 1 || dayNumber > daysInMonth) {
                    button.classList.add('et-affinity-reschedule-calendar__day--outside');
                    button.disabled = true;
                    button.tabIndex = -1;
                    button.textContent = '';
                    refs.grid.appendChild(button);
                    continue;
                }

                const dateValue = new Date(year, monthIndex, dayNumber);
                const isoDate = formatSimpleIsoDateForCalendar(dateValue);
                button.setAttribute('data-date', isoDate);
                button.textContent = String(dayNumber);

                const dayData = Array.isArray(currentDeliveryDays)
                    ? currentDeliveryDays.find(function(day) { return day && day.date === isoDate; })
                    : null;

                let isSelectable = false;
                if (dayData && !dayData.isClosed) {
                    const isEffectivelyClosed = typeof isDatePastClosingTime === 'function'
                        ? isDatePastClosingTime(dayData)
                        : false;
                    if (!isEffectivelyClosed) {
                        // Also ensure date/time is not in the past from store perspective
                        const isPast = typeof isDateTimePast === 'function'
                            ? isDateTimePast(isoDate, null)
                            : false;
                        isSelectable = !isPast;
                    }
                }

                if (!isSelectable) {
                    button.disabled = true;
                }

                if (deliveryCalendarSelectedDate === isoDate && isSelectable) {
                    button.classList.add('et-affinity-reschedule-calendar__day--selected');
                    button.setAttribute('aria-pressed', 'true');
                } else {
                    button.setAttribute('aria-pressed', 'false');
                }

                refs.grid.appendChild(button);
            }
        }

        function ensurePickupCalendarInitialized() {
            const refs = getPickupCalendarRefs();
            if (!refs) return;

            if (!pickupCalendarInitialized) {
                pickupCalendarInitialized = true;

                refs.prevButton.addEventListener('click', function() {
                    const bounds = getPickupCalendarBounds();
                    if (!pickupCalendarMonthDate) return;
                    const candidate = new Date(
                        pickupCalendarMonthDate.getFullYear(),
                        pickupCalendarMonthDate.getMonth() - 1,
                        1
                    );

                    if (bounds.min) {
                        const earliestMonth = new Date(bounds.min.getFullYear(), bounds.min.getMonth(), 1);
                        if (candidate < earliestMonth) {
                            return;
                        }
                    }

                    pickupCalendarMonthDate = candidate;
                    renderPickupCalendarGrid();
                });

                refs.nextButton.addEventListener('click', function() {
                    const bounds = getPickupCalendarBounds();
                    if (!pickupCalendarMonthDate) return;
                    const candidate = new Date(
                        pickupCalendarMonthDate.getFullYear(),
                        pickupCalendarMonthDate.getMonth() + 1,
                        1
                    );

                    if (bounds.max) {
                        const latestMonth = new Date(bounds.max.getFullYear(), bounds.max.getMonth(), 1);
                        if (candidate > latestMonth) {
                            return;
                        }
                    }

                    pickupCalendarMonthDate = candidate;
                    renderPickupCalendarGrid();
                });

                refs.grid.addEventListener('click', function(event) {
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return;
                    const dayButton = target.closest('button[data-date]');
                    if (!(dayButton instanceof HTMLButtonElement) || dayButton.disabled) {
                        return;
                    }
                    const nextDate = dayButton.getAttribute('data-date');
                    if (!nextDate) return;

                    pickupCalendarSelectedDate = nextDate;

                    const select = document.getElementById('fulfillment-date-pickup');
                    if (select) {
                        select.value = nextDate;
                    }

                    try {
                        if (nextDate) {
                            const fc = window.FulfillmentConstants || {};
                            const dateKey = fc.DATE || 'selected_fulfillment_date';
                            if (window.FulfillmentState && typeof window.FulfillmentState.set === 'function') {
                                window.FulfillmentState.set(dateKey, nextDate);
                            } else {
                                localStorage.setItem(dateKey, nextDate);
                            }
                        }
                    } catch (error) {
                        console.warn('Unable to persist pickup fulfillment date selection:', error);
                    }

                    dispatchCommittedFulfillmentDateChanged(nextDate);

                    renderPickupCalendarGrid();
                    updateBrowseButtonState();
                });
            }
        }

        function renderPickupCalendarGrid() {
            const refs = getPickupCalendarRefs();
            if (!refs) return;
            if (!Array.isArray(currentPickupDays) || currentPickupDays.length === 0) {
                refs.grid.innerHTML = '';
                refs.monthLabel.textContent = '';
                refs.prevButton.disabled = true;
                refs.nextButton.disabled = true;
                return;
            }

            const bounds = getPickupCalendarBounds();

            if (!pickupCalendarMonthDate) {
                let initialDate = null;
                if (pickupCalendarSelectedDate) {
                    initialDate = parseSimpleIsoDateForCalendar(pickupCalendarSelectedDate);
                }
                if (!initialDate && bounds.min) {
                    initialDate = bounds.min;
                }
                if (!initialDate) {
                    initialDate = new Date();
                }
                pickupCalendarMonthDate = new Date(
                    initialDate.getFullYear(),
                    initialDate.getMonth(),
                    1
                );
            }

            const monthStart = new Date(
                pickupCalendarMonthDate.getFullYear(),
                pickupCalendarMonthDate.getMonth(),
                1
            );

            // Update nav button disabled state based on bounds
            if (bounds.min) {
                const earliestMonth = new Date(bounds.min.getFullYear(), bounds.min.getMonth(), 1);
                const prevMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() - 1, 1);
                refs.prevButton.disabled = prevMonth < earliestMonth;
            } else {
                refs.prevButton.disabled = true;
            }

            if (bounds.max) {
                const latestMonth = new Date(bounds.max.getFullYear(), bounds.max.getMonth(), 1);
                const nextMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 1);
                refs.nextButton.disabled = nextMonth > latestMonth;
            } else {
                refs.nextButton.disabled = true;
            }

            refs.monthLabel.textContent = monthStart.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
            });

            const year = monthStart.getFullYear();
            const monthIndex = monthStart.getMonth();
            const firstWeekday = monthStart.getDay(); // 0 = Sunday
            const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

            refs.grid.innerHTML = '';

            for (let cellIndex = 0; cellIndex < 42; cellIndex += 1) {
                const dayNumber = cellIndex - firstWeekday + 1;
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'et-affinity-reschedule-calendar__day';

                if (dayNumber < 1 || dayNumber > daysInMonth) {
                    button.classList.add('et-affinity-reschedule-calendar__day--outside');
                    button.disabled = true;
                    button.tabIndex = -1;
                    button.textContent = '';
                    refs.grid.appendChild(button);
                    continue;
                }

                const dateValue = new Date(year, monthIndex, dayNumber);
                const isoDate = formatSimpleIsoDateForCalendar(dateValue);
                button.setAttribute('data-date', isoDate);
                button.textContent = String(dayNumber);

                const dayData = Array.isArray(currentPickupDays)
                    ? currentPickupDays.find(function(day) { return day && day.date === isoDate; })
                    : null;

                let isSelectable = false;
                if (dayData && !dayData.isClosed) {
                    const isEffectivelyClosed = typeof isDatePastClosingTime === 'function'
                        ? isDatePastClosingTime(dayData)
                        : false;
                    if (!isEffectivelyClosed) {
                        const isPast = typeof isDateTimePast === 'function'
                            ? isDateTimePast(isoDate, null)
                            : false;
                        isSelectable = !isPast;
                    }
                }

                if (!isSelectable) {
                    button.disabled = true;
                }

                if (pickupCalendarSelectedDate === isoDate && isSelectable) {
                    button.classList.add('et-affinity-reschedule-calendar__day--selected');
                    button.setAttribute('aria-pressed', 'true');
                } else {
                    button.setAttribute('aria-pressed', 'false');
                }

                refs.grid.appendChild(button);
            }
        }
        
        // Validate if a date/time combination is in the past
        function isDateTimePast(dateStr, timeStr) {
            if (!dateStr) return true; // No date = invalid
            
            // Get store timezone
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            
            const now = new Date();
            
            // Get current date in STORE timezone
            const todayInStoreStr = new Intl.DateTimeFormat("en-CA", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
                .format(now)
                .replace(/\//g, "-");
            
            // Compare dates as strings (YYYY-MM-DD format)
            if (dateStr < todayInStoreStr) {
                return true; // Date is in the past
            }
            
            // If it's today and we have a time, check if time is past (using STORE timezone)
            if (dateStr === todayInStoreStr && timeStr) {
                const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
                if (timeMatch) {
                    let hours = parseInt(timeMatch[1], 10);
                    const minutes = parseInt(timeMatch[2], 10);
                    const period = timeMatch[3].toUpperCase();
                    
                    if (period === 'PM' && hours !== 12) {
                        hours += 12;
                    } else if (period === 'AM' && hours === 12) {
                        hours = 0;
                    }
                    
                    const selectedTimeMinutes = hours * 60 + minutes;
                    
                    // Get current time in STORE timezone
                    let storeCurrentHour = 0;
                    let storeCurrentMinute = 0;
                    
                    try {
                        const timeFormatter = new Intl.DateTimeFormat("en-US", {
                            timeZone,
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                        });
                        
                        const timeParts = timeFormatter.formatToParts(now);
                        storeCurrentHour = parseInt(timeParts.find(p => p.type === 'hour')?.value || '0', 10);
                        storeCurrentMinute = parseInt(timeParts.find(p => p.type === 'minute')?.value || '0', 10);
                    } catch (err) {
                        console.error('Error getting store current time in isDateTimePast:', err);
                        // Fallback to browser time if timezone conversion fails
                        storeCurrentHour = now.getHours();
                        storeCurrentMinute = now.getMinutes();
                    }
                    
                    const currentTimeMinutes = storeCurrentHour * 60 + storeCurrentMinute;
                    
                    // Add 30min buffer - if time is within 30min, it's too late
                    if (selectedTimeMinutes < currentTimeMinutes + 30) {
                        return true;
                    }
                }
            }
            
            return false;
        }
        
        async function ensureFreshFulfillmentSelection(options = {}) {
            const opts = {
                syncCart: options.syncCart !== false,
                rerenderSummary: options.rerenderSummary === true,
            };
            const fc = window.FulfillmentConstants || {};
            const dateKey = fc.DATE || 'selected_fulfillment_date';
            const timeKey = fc.TIME || 'selected_fulfillment_time';
            const typeKey = fc.DELIVERY_TYPE || 'selected_delivery_type';
            let savedDate = localStorage.getItem(dateKey) || '';
            let savedTime = localStorage.getItem(timeKey) || '';
            const deliveryType = localStorage.getItem(typeKey) || '';

            if (!savedDate) {
                return { changed: false, invalidated: false, date: savedDate, time: savedTime };
            }

            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            const now = new Date();
            let todayStr;

            try {
                todayStr = new Intl.DateTimeFormat("en-CA", {
                    timeZone: timeZone,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }).format(now).replace(/\//g, "-");
            } catch (err) {
                todayStr = now.getFullYear() + '-' +
                    String(now.getMonth() + 1).padStart(2, '0') + '-' +
                    String(now.getDate()).padStart(2, '0');
            }

            let changed = false;
            let invalidated = false;

            if (deliveryType === 'delivery') {
                const inMemoryDeliveryDay = Array.isArray(currentDeliveryDays)
                    ? currentDeliveryDays.find(function(day) { return day && day.date === savedDate; })
                    : null;
                // Fall back to the persisted hours cache: the in-memory array is empty on
                // any page load where the modal's availability flow hasn't run.
                const selectedDay = inMemoryDeliveryDay || getCachedDayData('delivery', savedDate);
                const isClosedDay = !!(selectedDay && (selectedDay.isClosed || isDatePastClosingTime(selectedDay)));
                const shouldResetDeliverySelection =
                    !savedTime ||
                    savedDate < todayStr ||
                    isDateTimePast(savedDate, savedTime) ||
                    isClosedDay;

                if (shouldResetDeliverySelection) {
                    FulfillmentState.remove(dateKey);
                    FulfillmentState.remove(timeKey);
                    savedDate = '';
                    savedTime = '';
                    changed = true;
                    invalidated = true;
                }
            } else if (deliveryType === 'pickup') {
                const inMemoryPickupDay = Array.isArray(currentPickupDays)
                    ? currentPickupDays.find(function(day) { return day && day.date === savedDate; })
                    : null;
                const selectedPickupDay = inMemoryPickupDay || getCachedDayData('pickup', savedDate);
                const isClosedPickupDay = !!(selectedPickupDay && (selectedPickupDay.isClosed || isDatePastClosingTime(selectedPickupDay)));
                // Unlike delivery, pickup has no time-of-day check (isDateTimePast gets a
                // null time), so a SAME-DAY selection whose hours we can't determine must
                // fail closed — otherwise it can check out past closing time.
                const pickupHoursUnknown =
                    !selectedPickupDay || (!selectedPickupDay.isClosed && !selectedPickupDay.close);
                const shouldResetPickupSelection =
                    savedDate < todayStr ||
                    isDateTimePast(savedDate, null) ||
                    isClosedPickupDay ||
                    (savedDate === todayStr && pickupHoursUnknown);

                if (shouldResetPickupSelection) {
                    FulfillmentState.remove(dateKey);
                    FulfillmentState.remove(timeKey);
                    savedDate = '';
                    savedTime = '';
                    changed = true;
                    invalidated = true;
                }
            }

            if (invalidated) {
                changed = true;
                dispatchCommittedFulfillmentDateChanged(savedDate || '');
                try {
                    if (window.LocationCatalogPricing && typeof window.LocationCatalogPricing.refresh === 'function') {
                        window.LocationCatalogPricing.refresh();
                    }
                } catch (e) {}
            }

            if (changed && opts.syncCart && !isFulfillmentDraftMode() && typeof syncAllAttributesToCart === 'function') {
                try {
                    await syncAllAttributesToCart({ force: true });
                } catch (e) {}
            }

            if (changed && opts.rerenderSummary) {
                const locationName = localStorage.getItem(fc.LOCATION_NAME || 'selected_location_name');
                if (locationName) {
                    await renderDeliverySummaryBar(locationName);
                }
            }

            return { changed, invalidated, date: savedDate, time: savedTime };
        }
        window.ensureFreshFulfillmentSelection = ensureFreshFulfillmentSelection;

        async function reconcileDeliveryLocationFromZip(options = {}) {
            const opts = {
                syncCart: options.syncCart !== false
            };
            const fc = window.FulfillmentConstants || {};
            const deliveryType = localStorage.getItem(fc.DELIVERY_TYPE || 'selected_delivery_type') || '';
            if (deliveryType !== 'delivery') {
                return false;
            }

            const zipCode = (localStorage.getItem(fc.ZIP_CODE || 'selected_zip_code') || '').trim();
            if (!/^\d{5}$/.test(zipCode)) {
                return false;
            }

            let payload = getCachedZipData(zipCode);
            if (!payload || !payload.deliveryLocation || !payload.deliveryLocation.location_id || !payload.deliveryLocation.name) {
                try {
                    const res = await fetch(`${API_URL}/search/availability/${zipCode}`);
                    if (!res.ok) return false;
                    payload = await res.json();
                    if (payload) {
                        sessionStorage.setItem(`zipCache-${zipCode}`, JSON.stringify({ data: payload, timestamp: Date.now() }));
                    }
                } catch (e) {
                    return false;
                }
            }

            const deliveryLocation = payload && payload.deliveryLocation ? payload.deliveryLocation : null;
            if (!deliveryLocation || !deliveryLocation.location_id || !deliveryLocation.name) {
                return false;
            }

            const locationKey = fc.LOCATION_ID || 'selected_location_id';
            const locationNameKey = fc.LOCATION_NAME || 'selected_location_name';
            const timeZoneKey = fc.TIME_ZONE || 'selected_time_zone';

            const currentLocationId = (localStorage.getItem(locationKey) || '').trim();
            const currentLocationName = (localStorage.getItem(locationNameKey) || '').trim();
            const resolvedLocationId = String(deliveryLocation.location_id).trim();
            const resolvedLocationName = String(deliveryLocation.name).trim();
            const resolvedTimeZone = payload.locationTimeZone || '';

            const changed = currentLocationId !== resolvedLocationId || currentLocationName !== resolvedLocationName;
            if (!changed && (!resolvedTimeZone || localStorage.getItem(timeZoneKey) === resolvedTimeZone)) {
                return false;
            }

            FulfillmentState.set(locationKey, resolvedLocationId);
            FulfillmentState.set(locationNameKey, resolvedLocationName);
            if (resolvedTimeZone) {
                FulfillmentState.set(timeZoneKey, resolvedTimeZone);
            }

            if (opts.syncCart && !isFulfillmentDraftMode() && typeof syncAllAttributesToCart === 'function') {
                try {
                    await syncAllAttributesToCart({ force: true });
                } catch (e) {}
            }

            return true;
        }
        window.reconcileDeliveryLocationFromZip = reconcileDeliveryLocationFromZip;

        // Validate and clear expired fulfillment selections
        async function validateAndClearExpiredSelections() {
            return ensureFreshFulfillmentSelection({ syncCart: true, rerenderSummary: false });
        }
        
        // Parse time string like "9:00 AM" to [hours, minutes] in 24-hour format
        function parseTimeString(timeStr) {
            if (!timeStr) return [0, 0];
            const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
            if (!match) return [0, 0];
            
            let hours = parseInt(match[1]);
            const minutes = parseInt(match[2]);
            const period = match[3].toUpperCase();
            
            // Convert to 24-hour format
            if (period === 'PM' && hours !== 12) {
                hours += 12;
            } else if (period === 'AM' && hours === 12) {
                hours = 0;
            }
            
            return [hours, minutes];
        }
        
        // Format time like 14:30 to "2:30 PM"
        function formatPlainTime(hours, minutes) {
            const period = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours === 0 ? 12 : (hours > 12 ? hours - 12 : hours);
            const displayMinutes = String(minutes).padStart(2, '0');
            return `${displayHours}:${displayMinutes} ${period}`;
        }
        
        // Helper to get timezone offset string (e.g., "-08:00" for PST)
        function getOffsetForZone(date, timeZone) {
            if (!timeZone) return '+00:00';
            
            try {
                const options = {
                    timeZone: timeZone,
                    timeZoneName: 'shortOffset',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                };
                
                const formatter = new Intl.DateTimeFormat('en-US', options);
                const parts = formatter.formatToParts(date);
                const offsetPart = parts.find(p => p.type === 'timeZoneName');
                const offset = offsetPart?.value ?? 'GMT+0';
                
                // Parse offset like "GMT-8" or "GMT+5:30"
                const match = offset.match(/GMT([+-])(\d+)/);
                if (!match) return '+00:00';
                
                const sign = match[1];
                const hours = match[2].padStart(2, '0');
                
                return `${sign}${hours}:00`;
            } catch (err) {
                console.error('Error getting timezone offset:', err);
                return '+00:00';
            }
        }
        
        // Convert date string and time string to ISO format in the location's timezone
        function getLocalISOFromDateAndTime(dateStr, timeStr, timeZone) {
            if (!dateStr || !timeStr) return '';
            
            // Parse time (e.g., "2:30 PM" or "8:15 AM")
            const timeMatch = timeStr.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
            if (!timeMatch) {
                console.error('Invalid time format:', timeStr);
                return '';
            }
            
            let hours = parseInt(timeMatch[1], 10);
            const minutes = parseInt(timeMatch[2], 10);
            const period = timeMatch[3].toUpperCase();
            
            // Convert to 24-hour format
            if (period === 'PM' && hours < 12) {
                hours += 12;
            } else if (period === 'AM' && hours === 12) {
                hours = 0;
            }
            
            // Parse date (YYYY-MM-DD)
            const [yyyy, mm, dd] = dateStr.split('-');
            
            // Create a Date object to get the timezone offset
            const paddedHours = String(hours).padStart(2, '0');
            const paddedMinutes = String(minutes).padStart(2, '0');
            const jsDate = new Date(`${yyyy}-${mm}-${dd}T${paddedHours}:${paddedMinutes}:00`);
            
            // Get the timezone offset for the location
            const offset = getOffsetForZone(jsDate, timeZone);
            
            // Build ISO string with timezone offset
            const isoString = `${yyyy}-${mm}-${dd}T${paddedHours}:${paddedMinutes}:00${offset}`;
            
            return isoString;
        }

        // Generate time slots for a given date
        function generateDeliveryTimeSlots(dateValue, deliveryDaysOverride) {
            const deliveryDays = Array.isArray(deliveryDaysOverride) && deliveryDaysOverride.length > 0
                ? deliveryDaysOverride
                : currentDeliveryDays;
            if (!dateValue || !deliveryDays) return [];
            
            const dayData = deliveryDays.find(d => d.date === dateValue);
            if (!dayData || dayData.isClosed) return [];
            
            // Check if open and close times exist
            if (!dayData.open || !dayData.close) {
                return [];
            }
            
            const [startHour, startMin] = parseTimeString(dayData.open);
            const [endHour, endMin] = parseTimeString(dayData.close);
            
            // Add 45 minutes to the start time for delivery windows
            const startMinutes = startHour * 60 + startMin + 45;
            const adjustedStartHour = Math.floor(startMinutes / 60);
            const adjustedStartMin = startMinutes % 60;
            
            const slots = [];
            let currentHour = adjustedStartHour;
            let currentMin = adjustedStartMin;
            
            // Get timezone
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            
            const now = new Date();
            const nowDateStr = new Intl.DateTimeFormat("en-CA", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
                .format(now)
                .replace(/\//g, "-");
            
            const isToday = dateValue === nowDateStr;
            
            // Get current time in the STORE's timezone (not browser's)
            let storeCurrentHour = 0;
            let storeCurrentMinute = 0;
            
            if (isToday) {
                try {
                    const timeFormatter = new Intl.DateTimeFormat("en-US", {
                        timeZone,
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                    });
                    
                    const timeParts = timeFormatter.formatToParts(now);
                    storeCurrentHour = parseInt(timeParts.find(p => p.type === 'hour')?.value || '0', 10);
                    storeCurrentMinute = parseInt(timeParts.find(p => p.type === 'minute')?.value || '0', 10);
                    
                } catch (err) {
                    console.error('Error getting store current time:', err);
                    // Fallback to browser time if timezone conversion fails
                    storeCurrentHour = now.getHours();
                    storeCurrentMinute = now.getMinutes();
                }
            }
            
            const storeCurrentMinutes = storeCurrentHour * 60 + storeCurrentMinute;
            
            while (
                currentHour < endHour ||
                (currentHour === endHour && currentMin < endMin)
            ) {
                const slotMinutes = currentHour * 60 + currentMin;
                
                // Filter out past times using STORE timezone, with 30-minute buffer
                const shouldHide = isToday && slotMinutes < storeCurrentMinutes + 30;
                
                if (!shouldHide) {
                    const label = formatPlainTime(currentHour, currentMin);
                    slots.push({ label, value: label });
                }
                
                currentMin += 15;
                if (currentMin >= 60) {
                    currentMin = 0;
                    currentHour += 1;
                }
            }
            
            return slots;
        }
        
        // Check if fulfillment date and time are valid
        function isDeliverySelectionValid() {
            const deliveryType = getSelectedDeliveryOption();
            
            // For pickup, only date is required (time is auto-selected)
            if (deliveryType === 'pickup') {
                const dateSelect = document.getElementById('fulfillment-date-pickup');
                const selectedDate = dateSelect ? dateSelect.value : null;
                
                if (!selectedDate) {
                    return false;
                }
                
                const isValid = !isDateTimePast(selectedDate, null);
                return isValid;
            }
            
            // For delivery, check the ACTUAL modal select elements (not localStorage)
            const dateSelect = document.getElementById('fulfillment-date-delivery');
            const timeSelect = document.getElementById('fulfillment-time-delivery');
            
            const selectedDate = dateSelect ? dateSelect.value : null;
            const selectedTime = timeSelect ? timeSelect.value : null;

            if (!selectedDate || !selectedTime) {
                return false;
            }
            
            // Check if the selected date is in available delivery days
            if (currentDeliveryDays && currentDeliveryDays.length > 0) {
                const dateAvailable = currentDeliveryDays.find(day => day.date === selectedDate);
                if (!dateAvailable) {
                    return false;
                }
                if (dateAvailable.isClosed) {
                    return false;
                }
            }
            
            // Check if date/time combination is not in the past
            const isValid = !isDateTimePast(selectedDate, selectedTime);
            return isValid;
        }
        
        // Debounce timer for button state updates
        let browseButtonStateTimer = null;
        
        // Global variable to store the time change handler reference
        let globalTimeChangeHandler = null;
        
        // Update browse button state based on selection validity
        function updateBrowseButtonState() {
            // Debounce rapid state changes
            if (browseButtonStateTimer) {
                clearTimeout(browseButtonStateTimer);
            }
            
            browseButtonStateTimer = setTimeout(() => {
                const browseButton = document.getElementById('browse-menu-button');
                if (!browseButton) {
                    return;
                }
                
                // Don't update if button is currently executing
                if (isBrowseMealsExecuting) {
                    return;
                }
                
                const isValid = isDeliverySelectionValid();
                
                if (isValid) {
                    browseButton.disabled = false;
                    browseButton.removeAttribute('disabled');
                    browseButton.classList.remove('disabled');
                    browseButton.style.opacity = '';
                    browseButton.style.cursor = '';
                    browseButton.style.pointerEvents = '';
                } else {
                    browseButton.disabled = true;
                    browseButton.setAttribute('disabled', 'disabled');
                    browseButton.classList.add('disabled');
                    browseButton.style.opacity = '0.6';
                    browseButton.style.cursor = 'not-allowed';
                    browseButton.style.pointerEvents = 'none';
                }
            }, 100); // 100ms debounce
        }
        
        // Render time slots in the delivery time dropdown
        async function renderDeliveryTimeSlots(dateValue, options = {}) {
            const timeSelect = document.getElementById('fulfillment-time-delivery');
            if (!timeSelect) return;
            const preferEarliest = options.preferEarliest === true;
            
            // Remove existing event listener if it exists (prevent duplicates)
            if (globalTimeChangeHandler) {
                timeSelect.removeEventListener('change', globalTimeChangeHandler);
                // Remove input listener - it causes issues on Safari mobile
                // timeSelect.removeEventListener('input', globalTimeChangeHandler);
            }
            
            // Clear existing options
            timeSelect.innerHTML = '<option value="">Select a time</option>';
            
            // Generate time slots
            const slots = generateDeliveryTimeSlots(dateValue);
            
            if (slots.length === 0) {
                timeSelect.disabled = true;
                updateBrowseButtonState();
                return;
            }
            
            timeSelect.disabled = false;
            
            // Add time slot options
            slots.forEach(slot => {
                const option = document.createElement('option');
                option.value = slot.value;
                option.textContent = slot.label;
                timeSelect.appendChild(option);
            });
            
            let timeRestored = false;
            let timeToRestore = null;
            
            if (!preferEarliest) {
                // Try to restore saved time from localStorage first, then from cart
                const savedTime = getFulfillmentStateValue('selected_fulfillment_time');
                
                // First try localStorage (date/time cleared when zip changes, so saved is valid for current context)
                if (savedTime && !isDateTimePast(dateValue, savedTime)) {
                    timeToRestore = savedTime;
                }
                
                // If not in localStorage, try to get from cart
                if (!timeToRestore && !isFulfillmentDraftMode()) {
                    try {
                        const cartResponse = await fetch('/cart.js');
                        const cart = await cartResponse.json();
                        const attrs = cart.attributes || {};
                        
                        const explicitTime = attrs['_selectedFulfillmentTime'];
                        if (explicitTime && typeof explicitTime === 'string' && explicitTime.trim()) {
                            const fulfillmentDateAttr = attrs['Fulfillment Date'];
                            const cartDatePart = fulfillmentDateAttr ? (String(fulfillmentDateAttr).includes('T') ? String(fulfillmentDateAttr).split('T')[0] : String(fulfillmentDateAttr).split(/\s+/)[0] || '') : '';
                            const expectedDatePart = dateValue ? (String(dateValue).includes('T') ? String(dateValue).split('T')[0] : String(dateValue).split(/\s+/)[0] || '') : '';
                            if (cartDatePart && expectedDatePart && cartDatePart === expectedDatePart) {
                                timeToRestore = explicitTime.trim();
                            }
                        }

                        if (!timeToRestore) {
                            const fulfillmentDateAttr = attrs['Fulfillment Date'];
                            if (fulfillmentDateAttr) {
                                const parts = fulfillmentDateAttr.split('T');
                                if (parts.length === 2 && parts[1]) {
                                    const timePart = parts[1].split(':');
                                    if (timePart.length >= 2) {
                                        const hour = parseInt(timePart[0]);
                                        const minute = parseInt(timePart[1]);
                                        const formattedTime = formatPlainTime(hour, minute);
                                        for (let i = 0; i < timeSelect.options.length; i++) {
                                            if (timeSelect.options[i].value === formattedTime) {
                                                timeToRestore = formattedTime;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        console.error('Error fetching cart for time restoration:', err);
                    }
                }
            }
            
            // Restore the time if found
            if (timeToRestore) {
                for (let i = 0; i < timeSelect.options.length; i++) {
                    if (timeSelect.options[i].value === timeToRestore) {
                        timeSelect.value = timeToRestore;
                        timeRestored = true;
                        
                        FulfillmentState.set('selected_fulfillment_time', timeToRestore);
                        
                        break;
                    }
                }
            }

            if (!timeRestored && slots.length > 0) {
                timeToRestore = slots[0].value;
                for (let i = 0; i < timeSelect.options.length; i++) {
                    if (timeSelect.options[i].value === timeToRestore) {
                        timeSelect.value = timeToRestore;
                        timeRestored = true;
                        FulfillmentState.set('selected_fulfillment_time', timeToRestore);
                        break;
                    }
                }
            }
            
            if (!timeRestored) {
                FulfillmentState.remove('selected_fulfillment_time');
                
                // Also clear from cart to avoid stale time data
                fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        const currentAttributes = cart.attributes || {};
                        const updatedAttributes = {...currentAttributes};
                        delete updatedAttributes['Fulfillment Date'];
                        delete updatedAttributes['_selectedFulfillmentTime'];
                        
                        return fetch('/cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ attributes: updatedAttributes })
                        });
                    })
                    .then(() => {
                        // Re-render summary bar without time
                        const locationName = getFulfillmentStateValue('selected_location_name');
                        if (locationName) {
                            renderDeliverySummaryBar(locationName);
                        }
                    })
                    .catch(err => console.error('Error clearing cart time:', err));
            }
            
            // Update browse button state after restoring time
            updateBrowseButtonState();
            
            // Create and store the change event handler
            const handleTimeChange = async (e) => {
                // Prevent rapid firing on Safari mobile by adding a small debounce
                if (handleTimeChange.isProcessing) return;
                handleTimeChange.isProcessing = true;

                // Show loading overlay for immediate feedback
                const loadingOverlay = document.getElementById('loading-overlay');
                if (loadingOverlay) {
                    loadingOverlay.style.display = 'flex';
                    loadingOverlay.style.opacity = '1';
                }

                try {
                    const nextTime = e && e.target ? e.target.value : '';
                    if (nextTime) {
                        FulfillmentState.set('selected_fulfillment_time', nextTime);
                    } else {
                        FulfillmentState.remove('selected_fulfillment_time');
                    }
                    // Just update button state - NO localStorage or cart updates until Browse Menu click
                    updateBrowseButtonState();

                    // Force a small delay to ensure UI updates on mobile
                    await new Promise(resolve => setTimeout(resolve, 50));
                } finally {
                     // Hide loading overlay
                    if (loadingOverlay) {
                        loadingOverlay.style.opacity = '0';
                        setTimeout(() => loadingOverlay.style.display = 'none', 300);
                    }
                }

                // Reset processing flag after a short delay
                setTimeout(() => {
                    handleTimeChange.isProcessing = false;
                }, 100);
            };
            
            // Remove previous listener if it exists
            if (globalTimeChangeHandler) {
                timeSelect.removeEventListener('change', globalTimeChangeHandler);
                // Remove input listener - it causes issues on Safari mobile
                // timeSelect.removeEventListener('input', globalTimeChangeHandler);
            }

            // Update global reference
            globalTimeChangeHandler = handleTimeChange;

            // Add the event listener (only 'change' for Safari mobile compatibility)
            timeSelect.addEventListener('change', globalTimeChangeHandler);
            // Removed 'input' event listener - it causes double-firing on Safari mobile
        }
        
        // Guard to prevent duplicate cart updates
        let isUpdatingCart = false;
        let lastUpdateKey = null;
        let cartUpdateTimer = null;
        
        // Update cart with the full ISO datetime for "Fulfillment Date"
        async function updateCartFulfillmentDate(dateValue, timeValue) {
            if (!dateValue || !timeValue) {
                return;
            }
            
            const timeZone = getFulfillmentStateValue("selected_time_zone") || "America/Los_Angeles";
            const isoDateTime = getLocalISOFromDateAndTime(dateValue, timeValue, timeZone);
            
            if (!isoDateTime) {
                console.error('Failed to generate ISO datetime', { dateValue, timeValue, timeZone });
                return;
            }
            
            const updateKey = `${dateValue}_${timeValue}`;
            
            if (isUpdatingCart && lastUpdateKey === updateKey) {
                return;
            }
            
            if (cartUpdateTimer) {
                clearTimeout(cartUpdateTimer);
            }
            
            cartUpdateTimer = setTimeout(async () => {
                if (isUpdatingCart && lastUpdateKey === updateKey) {
                    return;
                }
                
                isUpdatingCart = true;
                lastUpdateKey = updateKey;
                
                
                try {
                    const cartResponse = await fetch('/cart.js');
                    const cart = await cartResponse.json();
                    const currentAttributes = cart.attributes || {};
                    
                    if (currentAttributes['Fulfillment Date'] === isoDateTime) {
                        isUpdatingCart = false;
                        return;
                    }
                  
                    const fc = window.FulfillmentConstants || {};
                    const locZip = getFulfillmentStateValue(fc.ZIP_CODE || "selected_zip_code") || "";
                    const locTimeZone = getFulfillmentStateValue(fc.TIME_ZONE || "selected_time_zone") || "America/Los_Angeles";
                    const locDeliveryType = getFulfillmentStateValue(fc.DELIVERY_TYPE || "selected_delivery_type") || "";
                    const locLocationId = getFulfillmentStateValue(fc.LOCATION_ID || "selected_location_id") || "";
                    const locLocationName = getFulfillmentStateValue(fc.LOCATION_NAME || "selected_location_name") || "";

                    const updatedAttributes = {
                        ...currentAttributes,
                        "_zipCode": locZip,
                        "_selectedFulfillmentDate": dateValue,
                        "_timeZone": locTimeZone,
                        "Fulfillment Type": locDeliveryType,
                        "LocationID": locLocationId,
                        "_locationName": locLocationName,
                        "Fulfillment Date": isoDateTime,
                        "_selectedFulfillmentTime": timeValue,
                    };
                    
                    const updateResponse = await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ attributes: updatedAttributes })
                    });
                    
                    await updateResponse.json();
                    
                } catch (error) {
                    console.error('Failed to update cart Fulfillment Date:', error);
                } finally {
                    setTimeout(() => {
                        isUpdatingCart = false;
                        lastUpdateKey = null;
                    }, 500);
                }
            }, 300);
        }
        
        async function renderDeliveryDates(dates, options = {}) {
            currentDeliveryDays = dates;
            const preferEarliestTime = options.preferEarliestTime === true;
            
            await validateAndClearExpiredSelections();
            
            const select = document.getElementById('fulfillment-date-delivery');
            select.innerHTML = '';
            
            const currentZipCode = getFulfillmentStateValue('selected_zip_code');

            const timeZone = getFulfillmentStateValue("selected_time_zone") || "America/Los_Angeles";
            const now = new Date();
            
            let todayStr, tomorrowStr;
            try {
                const dateFormatter = new Intl.DateTimeFormat("en-CA", {
                    timeZone: timeZone,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                
                todayStr = dateFormatter.format(now).replace(/\//g, "-");
                
                const tomorrowDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                tomorrowStr = dateFormatter.format(tomorrowDate).replace(/\//g, "-");
            } catch (err) {
                console.error('Error getting dates in store timezone:', err);
                todayStr = now.getFullYear() + '-' + 
                           String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                           String(now.getDate()).padStart(2, '0');
                const tomorrow = new Date(now);
            tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrowStr = tomorrow.getFullYear() + '-' + 
                              String(tomorrow.getMonth() + 1).padStart(2, '0') + '-' + 
                              String(tomorrow.getDate()).padStart(2, '0');
            }

            const getFormattedLabel = (dateStr) => {
                if (dateStr === todayStr) return "Today";
                if (dateStr === tomorrowStr) return "Tomorrow";
                const [year, month, dayNum] = dateStr.split('-');
                const date = new Date(`${year}-${month}-${dayNum}T00:00:00`);
                const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
                const monthName = date.toLocaleDateString('en-US', { month: 'long' });
                return `${weekday}, ${monthName} ${parseInt(dayNum, 10)}`;
            };

            dates.forEach(day => {
                const option = document.createElement('option');
                option.value = day.date;
                const label = getFormattedLabel(day.date);

                const isEffectivelyClosed = day.isClosed || isDatePastClosingTime(day);

                if (isEffectivelyClosed) {
                    option.textContent = `${label} [Closed]`;
                    option.disabled = true;
                } else {
                    option.textContent = label;
                }

                select.appendChild(option);
            });

            const savedDeliveryDate = getFulfillmentStateValue('selected_fulfillment_date');
            
            let dateRestored = false;
            let dateToRestore = null;
            
            if (savedDeliveryDate) {
                for (let i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === savedDeliveryDate && !select.options[i].disabled) {
                        dateToRestore = savedDeliveryDate;
                        break;
                    }
                }
            }
            
            // If not in localStorage, try to get from cart
            if (!dateToRestore && !isFulfillmentDraftMode()) {
                try {
                    const cartResponse = await fetch('/cart.js');
                    const cart = await cartResponse.json();
                    const fulfillmentDateAttr = cart.attributes?.['Fulfillment Date'];
                    const selectedFulfillmentDateAttr = cart.attributes?.['_selectedFulfillmentDate'];
                    
                    // Try _selectedFulfillmentDate first (just date), then extract from Fulfillment Date
                    if (selectedFulfillmentDateAttr) {
                        dateToRestore = selectedFulfillmentDateAttr;
                    } else if (fulfillmentDateAttr) {
                        // Extract date from ISO string (e.g., "2025-12-12T08:15:00" -> "2025-12-12")
                        const parts = fulfillmentDateAttr.split('T');
                        if (parts.length > 0 && parts[0]) {
                            dateToRestore = parts[0];
                        }
                    }
                    
                } catch (err) {
                    console.error('Error fetching cart for date restoration:', err);
                }
            }
            
            if (dateToRestore) {
                for (let i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === dateToRestore && !select.options[i].disabled) {
                        select.value = dateToRestore;
                        dateRestored = true;
                        
                        FulfillmentState.set('selected_fulfillment_date', dateToRestore);
                        
                        break;
                    }
                }
            }
            
            // If date wasn't restored or ZIP changed, select first available
            if (!dateRestored) {
                for (let i = 0; i < select.options.length; i++) {
                    if (!select.options[i].disabled) {
                        select.value = select.options[i].value;
                        FulfillmentState.set('selected_fulfillment_date', select.value);
                        break;
                    }
                }
            } else if (select.value) {
                FulfillmentState.set('selected_fulfillment_date', select.value);
            }

            // Generate time slots for the selected date (await so time is populated before modal is shown)
            if (select.value) {
                await renderDeliveryTimeSlots(select.value, { preferEarliest: preferEarliestTime });
            } else {
                // No date selected, ensure button state is updated
                updateBrowseButtonState();
            }

            // Remove existing date change listener if it exists (prevent duplicates)
            if (dateChangeHandler) {
                select.removeEventListener('change', dateChangeHandler);
                dateChangeHandler = null;
            }
            
            // Create and store the date change handler (only one instance)
            dateChangeHandler = () => {
                const newDate = select.value;
                FulfillmentState.set('selected_fulfillment_date', newDate);
                
                // Clear time select element when date changes
                const timeSelect = document.getElementById('fulfillment-time-delivery');
                if (timeSelect) {
                    timeSelect.value = '';
                }
                
                // Regenerate time slots for the new date
                renderDeliveryTimeSlots(newDate, { preferEarliest: true });
                
                // Update browse button state
                updateBrowseButtonState();

                deliveryCalendarSelectedDate = newDate || null;
                const deliveryDate = deliveryCalendarSelectedDate ? parseSimpleIsoDateForCalendar(deliveryCalendarSelectedDate) : null;
                deliveryCalendarMonthDate = deliveryDate ? new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), 1) : null;
                ensureDeliveryCalendarInitialized();
                renderDeliveryCalendarGrid();
            };
            
            // Add the event listener (only once)
            select.addEventListener('change', dateChangeHandler);

            // Keep the inline calendar in sync with the select element
            deliveryCalendarSelectedDate = select.value || null;
            const deliveryDate = deliveryCalendarSelectedDate ? parseSimpleIsoDateForCalendar(deliveryCalendarSelectedDate) : null;
            deliveryCalendarMonthDate = deliveryDate ? new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), 1) : null;
            ensureDeliveryCalendarInitialized();
            renderDeliveryCalendarGrid();
        }
        function openUnavailableModal() {
            document.getElementById('zip-unavailable-modal').classList.remove('hidden');

            // Pre-fill the ZIP code from the main modal input
            const mainZipInput = document.getElementById('zip');
            const notifyZipInput = document.getElementById('notify-zip');
            if (mainZipInput && notifyZipInput && mainZipInput.value.trim()) {
                notifyZipInput.value = mainZipInput.value.trim();
            }

            const emailInput = document.getElementById('notify-email');
            if (emailInput) {
                setTimeout(() => emailInput.focus(), 100);
            }
        }

        function closeUnavailableModal() {
            document.getElementById('zip-unavailable-modal').classList.add('hidden');

            // Clear form fields for next use
            const notifyZipInput = document.getElementById('notify-zip');
            const notifyEmailInput = document.getElementById('notify-email');
            if (notifyZipInput) notifyZipInput.value = '';
            if (notifyEmailInput) notifyEmailInput.value = '';
        }

        async function submitNotifyEmail() {
            const emailInput = document.getElementById('notify-email');
            const zipInput = document.getElementById('notify-zip');
            const email = emailInput.value.trim();
            const zipCode = zipInput.value.trim();

            if (!email) {
                alert('Please enter your email address.');
                emailInput.focus();
                return;
            }

            if (!zipCode || zipCode.length < 5) {
                alert('Please enter a valid 5-digit ZIP code.');
                zipInput.focus();
                return;
            }

            if (!/^\d{5}$/.test(zipCode)) {
                alert('Please enter a valid 5-digit ZIP code.');
                zipInput.focus();
                return;
            }

            try {
                const response = await fetch(`${API_URL}/notify-customers`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        email,
                        zip_code: zipCode
                    })
                });

                if (!response.ok) {
                    const data = await response.json();
                    if (response.status === 409) {
                        alert("You're already on the waitlist for this zip code.");
                    } else {
                        alert("Something went wrong. Please try again later.");
                    }
                    return;
                }

                closeUnavailableModal();
                alert("Thank you! We'll notify you when we expand to your area.");
            } catch (err) {
                alert("There was a problem submitting your email.");
            }
        }



        function renderPickupLocations(locations, opts = {}) {
            const persist = opts.persist !== false;
            const container = document.querySelector('.pickup-locations');
            if (!container) {
                return;
            }
            container.innerHTML = ''; // Clear existing

            locations.forEach((loc, index) => {
                // Skip locations with missing shopifyLocation or address
                if (!loc.shopifyLocation || !loc.shopifyLocation.address) {
                    return;
                }

                const { shopifyLocation, distance_from_entered_zip_code } = loc;
                const id = `location-${index}`;
                
                // Additional safety checks
                if (!shopifyLocation.name) {
                    return;
                }
                
                if (!shopifyLocation.address.zip) {
                    return;
                }
                
                const shopifyLocationZipCode = shopifyLocation.address.zip;

                const locationHTML = `
                          <div class="pickup-location">
                            <input
                              type="radio"
                              id="${id}"
                              name="pickup-location"
                              data-location-id="${escapeHtmlAttribute(loc.location_id)}"
                              data-location-name="${escapeHtmlAttribute(shopifyLocation.name)}"
                              data-location-zip="${escapeHtmlAttribute(shopifyLocationZipCode)}"
                              data-location="${escapeHtmlAttribute(JSON.stringify(loc))}"
                              data-pickup-dates="${escapeHtmlAttribute(JSON.stringify(loc.pickupDates || []))}"
                              ${index === 0 ? 'checked' : ''}>
                            <label for="${id}">
                              <div class="location-details">
                                <div class="retail-label">RETAIL LOCATION</div>
                                <div class="location-name">${shopifyLocation.name} - ${shopifyLocation.address.address1}</div>
                              </div>
                              <div class="distance">${distance_from_entered_zip_code && !isNaN(distance_from_entered_zip_code) ? distance_from_entered_zip_code.toFixed(1) : 'N/A'} mi</div>
                            </label>
                          </div>
                        `;



                container.insertAdjacentHTML('beforeend', locationHTML);
            });

            let checkedRadio = container.querySelector('input[name="pickup-location"]:checked');
            // On change, update localStorage with ZIP as well
            document.querySelectorAll('input[name="pickup-location"]').forEach(input => {
                input.addEventListener('change', async () => {
                    try {
                        const loc = JSON.parse(input.getAttribute('data-location'));
                        const zip = input.getAttribute('data-location-zip');
                        
                        // Safety check for shopifyLocation
                        if (!loc.shopifyLocation || !loc.shopifyLocation.name) {
                            return;
                        }
                        
                        const timeZone = loc.time_zone || loc.shopifyLocation?.time_zone;
                        updatePickupDates(input);

                        FulfillmentState.set('selected_location_id', loc.location_id);
                        FulfillmentState.set('selected_location_name', loc.shopifyLocation.name);
                        /* Catalog fetch deferred until user commits (Browse Menu) — avoids wasteful API calls before confirmation */
                        // DO NOT overwrite user's ZIP with pickup location ZIP
                        // Only save pickup location ZIP if in pickup mode
                        if (getSelectedDeliveryOption() === 'pickup') {
                            FulfillmentState.set('selected_zip_code', zip);
                        }

                        if (timeZone) {
                            FulfillmentState.set("selected_time_zone", timeZone);
                        }
                        
                        /* Catalog fetch deferred until user commits (Browse Menu) */
                    } catch (error) {
                        console.error('Failed to process location change:', error);
                    }
                });
            });

            // Set fallback defaults only if no valid location is already selected
            const firstLoc = locations[0];
            if (firstLoc) {
                // Safety check for firstLoc
                if (!firstLoc.shopifyLocation || !firstLoc.shopifyLocation.name) {
                    return;
                }
                
                // Check if user already has a valid location selected that exists in this list
                const existingLocationId = localStorage.getItem('selected_location_id');
                const isExistingLocationInList = existingLocationId && 
                    locations.some(l => String(l.location_id) === existingLocationId);
                
                const activeLoc = isExistingLocationInList
                    ? locations.find(l => String(l.location_id) === existingLocationId)
                    : firstLoc;
                if (isExistingLocationInList) {
                    const existingRadio = container.querySelector(
                        `input[name="pickup-location"][data-location-id="${existingLocationId}"]`
                    );
                    if (existingRadio && !existingRadio.checked) {
                        existingRadio.checked = true;
                    }
                    checkedRadio = existingRadio || checkedRadio;
                } else {
                    if (persist) {
                        FulfillmentState.set('selected_location_id', firstLoc.location_id);
                        FulfillmentState.set('selected_location_name', firstLoc.shopifyLocation.name);
                    }
                }
                
                if (persist && getSelectedDeliveryOption() === 'pickup' && activeLoc?.shopifyLocation?.address?.zip) {
                    const pickupZip = activeLoc.shopifyLocation.address.zip;
                    const activeTimeZone = activeLoc.time_zone || activeLoc.shopifyLocation?.time_zone;
                    FulfillmentState.set('selected_zip_code', pickupZip);
                    if (activeTimeZone) FulfillmentState.set('selected_time_zone', activeTimeZone);

                    Object.keys(sessionStorage).forEach((key) => {
                        if (key.startsWith('zipCache-')) {
                            sessionStorage.removeItem(key);
                        }
                    });
                }
            }
            if (checkedRadio) {
                updatePickupDates(checkedRadio);
            }
        }

        function updatePickupDates(radio) {
            const dates = JSON.parse(radio.getAttribute('data-pickup-dates') || '[]');
            const select = document.getElementById('fulfillment-date-pickup');
            if (!select) return;
            select.innerHTML = '';

            // Keep a copy of pickup days for the inline calendar
            currentPickupDays = Array.isArray(dates) ? dates : [];
            
            // Get current zipcode and location for validation
            const currentZipCode = localStorage.getItem('selected_zip_code');
            const currentLocationId = radio.getAttribute('data-location-id') || radio.id || null;

            // Get today and tomorrow in STORE timezone (not browser timezone)
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            const now = new Date();
            
            let todayStr, tomorrowStr;
            try {
                const dateFormatter = new Intl.DateTimeFormat("en-CA", {
                    timeZone: timeZone,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                
                todayStr = dateFormatter.format(now).replace(/\//g, "-");
                
                const tomorrowDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                tomorrowStr = dateFormatter.format(tomorrowDate).replace(/\//g, "-");
            } catch (err) {
                console.error('Error getting dates in store timezone:', err);
                // Fallback to browser timezone
                todayStr = now.getFullYear() + '-' + 
                           String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                           String(now.getDate()).padStart(2, '0');
                const tomorrow = new Date(now);
            tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrowStr = tomorrow.getFullYear() + '-' + 
                              String(tomorrow.getMonth() + 1).padStart(2, '0') + '-' + 
                              String(tomorrow.getDate()).padStart(2, '0');
            }

            const getFormattedLabel = (dateStr) => {
                if (dateStr === todayStr) return "Today";
                if (dateStr === tomorrowStr) return "Tomorrow";

                const [year, month, dayNum] = dateStr.split('-');
                const date = new Date(`${year}-${month}-${dayNum}T00:00:00`);
                const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
                const monthName = date.toLocaleDateString('en-US', { month: 'long' });
                return `${weekday}, ${monthName} ${parseInt(dayNum, 10)}`;
            };

            dates.forEach(day => {
                const option = document.createElement('option');
                option.value = day.date;
                const label = getFormattedLabel(day.date);

                // Check if day is closed OR if it's today and past closing time
                const isEffectivelyClosed = day.isClosed || isDatePastClosingTime(day);

                if (isEffectivelyClosed) {
                    option.textContent = `${label} [Closed]`;
                    option.disabled = true;
                } else {
                    option.textContent = label;
                }

                select.appendChild(option);
            });

            // Restore previously selected pickup date if still valid
            const savedPickupDate = localStorage.getItem('selected_fulfillment_date');
            
            let dateSelected = false;
            
            if (savedPickupDate && !isDateTimePast(savedPickupDate, null)) {
                for (let i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === savedPickupDate && !select.options[i].disabled) {
                        select.value = savedPickupDate;
                        dateSelected = true;
                        break;
                    }
                }
            }
            
            // If no valid date was selected, select the first available date
            if (!dateSelected && select.options.length > 0) {
                for (let i = 0; i < select.options.length; i++) {
                    if (!select.options[i].disabled) {
                        select.value = select.options[i].value;
                        break;
                    }
                }
            }
            
            if (select.options.length > 0 && select.value) {
                FulfillmentState.set('selected_fulfillment_date', select.value);
                
                dispatchCommittedFulfillmentDateChanged(select.value);
                
                // Update browse button state when pickup dates are populated
                updateBrowseButtonState();

                // Sync inline pickup calendar with the currently selected date
                pickupCalendarSelectedDate = select.value || null;
                const pickupDate = pickupCalendarSelectedDate ? parseSimpleIsoDateForCalendar(pickupCalendarSelectedDate) : null;
                pickupCalendarMonthDate = pickupDate ? new Date(pickupDate.getFullYear(), pickupDate.getMonth(), 1) : null;
                ensurePickupCalendarInitialized();
                renderPickupCalendarGrid();
            }

            if (select._onPickupDateChange) {
                select.removeEventListener('change', select._onPickupDateChange);
            }

            select._onPickupDateChange = function onPickupDateChange() {
                const newDate = select.value;
                FulfillmentState.set('selected_fulfillment_date', newDate);
                
                dispatchCommittedFulfillmentDateChanged(newDate);
                
                // Update browse button state when pickup date changes
                updateBrowseButtonState();

                // Keep the inline pickup calendar in sync with the newly selected date
                pickupCalendarSelectedDate = newDate || null;
                const pickupDate = pickupCalendarSelectedDate ? parseSimpleIsoDateForCalendar(pickupCalendarSelectedDate) : null;
                pickupCalendarMonthDate = pickupDate ? new Date(pickupDate.getFullYear(), pickupDate.getMonth(), 1) : null;
                ensurePickupCalendarInitialized();
                renderPickupCalendarGrid();
            };

            select.addEventListener('change', select._onPickupDateChange);
        }



        function populateDeliveryDetails(deliveryLocation) {
            // example usage — currently hardcoded
            const select = document.getElementById("delivery-date");
            select.innerHTML = `
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
              `;
        }



        function backToZipStep() {
            document.getElementById('delivery-step-two').classList.add('hidden');

            // Remove options-view class when going back to first step
            document.querySelector('.delivery-modal-inner-wrapper').classList.remove('options-view');
        }


        let currentUrl = window.location.href;

        document.addEventListener('facet:change', (event) => {
            fetchUpdatedCollectionGrid(window.location.href);
        });

        (function () {
            let currentPath = location.pathname + location.search;

            // Key to store the HTML cache
            const CACHE_PREFIX = 'collection-html-cache:';

            async function fetchAndUpdateGrid() {
                const cacheKey = CACHE_PREFIX + window.location.pathname + window.location.search;
                const cachedHtml = sessionStorage.getItem(cacheKey);

                if (cachedHtml) {
                    updateGridFromHTML(cachedHtml);
                    currentPath = location.pathname + location.search;
                    return;
                }

                try {
                    const res = await fetch(window.location.href, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);

                    const html = await res.text();
                    sessionStorage.setItem(cacheKey, html);
                    updateGridFromHTML(html);

                    currentPath = location.pathname + location.search;
                } catch (err) {
                }
            }

            function updateGridFromHTML(html) {
                const temp = document.createElement('div');
                temp.innerHTML = html;

                const newGrid = temp.querySelector('#product-grid');
                const currentGrid = document.querySelector('#product-grid');

                if (newGrid && currentGrid) {
                    currentGrid.innerHTML = newGrid.innerHTML;

                    // Call pricing logic after grid is replaced
                    maybeFetchCatalogPricing();
                }
            }

            // Monitor URL changes
            const onUrlChange = () => {
                const newPath = location.pathname + location.search;
                if (newPath !== currentPath) {
                    fetchAndUpdateGrid();
                }
            };

            // Patch pushState and replaceState
            const patchHistory = (method) => {
                const original = history[method];
                history[method] = function (...args) {
                    const result = original.apply(this, args);
                    onUrlChange();
                    return result;
                };
            };

            window.addEventListener('popstate', onUrlChange);
            patchHistory('pushState');
            patchHistory('replaceState');
        })();




        function fetchUpdatedCollectionGrid(url) {
            // Only fetch the collection grid section (e.g., with section ID or target DOM)
            fetch(url)
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newGrid = doc.querySelector('#ProductGridContainer');
                    const currentGrid = document.querySelector('#ProductGridContainer');

                    if (newGrid && currentGrid) {
                        currentGrid.innerHTML = newGrid.innerHTML;
                    }
                });
        }

        async function selectDeliveryOption(option, opts = {}) {
            // Get previous selection for comparison
            const previousOption = getSelectedDeliveryOption();

            if (opts.autoSelect !== true) {
                deliveryOptionManuallyChosen = true;
            }
            
            if (opts.persist !== false) {
                FulfillmentState.set('selected_delivery_type', option);
            }

            


            // Remove active class from all tabs
            document.querySelectorAll('.option-tab').forEach(tab => {
                tab.classList.remove('active');

                // Restore original icon if not selected
                const svg = tab.querySelector('svg');
                const original = tab.getAttribute('data-original-icon');
                if (original) {
                    svg.outerHTML = original;
                }
            });

            // Add active class to selected tab
            const selectedTab = document.getElementById(option + '-tab');
            if (selectedTab) {
                selectedTab.classList.add('active');
            }

            // Replace icon with checkmark
            const icon = selectedTab?.querySelector('svg');
            if (icon) {
                if (!selectedTab.getAttribute('data-original-icon')) {
                    selectedTab.setAttribute('data-original-icon', icon.outerHTML);
                }
                icon.outerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" stroke="white" fill="none"/>
                <path d="M9 12l2 2l4-4" />
            </svg>
        `;
            }

            // Show/hide sections
            const deliverySection = document.getElementById('delivery-section');
            const pickupSection = document.getElementById('pickup-section');
            
            if (deliverySection) {
                deliverySection.classList.toggle('hidden', option !== 'delivery');
            }
            
            if (pickupSection) {
                pickupSection.classList.toggle('hidden', option !== 'pickup');
            }

            // Handle delivery to pickup switch
            if (previousOption === 'delivery' && option === 'pickup') {
                await handleDeliveryToPickupSwitch();
            }
           
            // Handle pickup to delivery switch
            if (previousOption === 'pickup' && option === 'delivery') {
                await handlePickupToDeliverySwitch();
            }
            
            // Always update cart attributes when switching
            await updateCartDeliveryAttributes(option);
        }
        
        // Make selectDeliveryOption globally accessible for onclick handlers
        window.selectDeliveryOption = selectDeliveryOption;

        function storeOriginalFormValues() {
            // Store original zip code value
            const zipInput = document.getElementById('zip');
            window.originalZipCode = zipInput ? zipInput.value.trim() : '';

            // Store original pickup location value
            const selectedPickupRadio = document.querySelector('input[name="pickup-location"]:checked');
            window.originalPickupLocation = selectedPickupRadio ? selectedPickupRadio.getAttribute('data-location-name') || '' : '';
        }

        async function browseMeals() {
            // Prevent multiple simultaneous calls
            if (isBrowseMealsExecuting) {
                return;
            }
            
            const browseButton = document.querySelector('#browse-menu-button, .delivery-modal-continue-button');
            if (browseButton && (browseButton.disabled || browseButton.hasAttribute('disabled') || browseButton.classList.contains('disabled'))) {
                return;
            }
            
            isBrowseMealsExecuting = true;
            const originalButtonText = browseButton?.innerHTML;
            if (browseButton) {
                browseButton.disabled = true;
                browseButton.classList.add('loading');
                browseButton.innerHTML = '<span class="button-spinner"></span> Checking prices...';
            }

            try {
                // VALIDATE: Check if fulfillment date/time selection is valid
                if (!isDeliverySelectionValid()) {
                    if (browseButton) { browseButton.disabled = false; browseButton.classList.remove('loading'); browseButton.innerHTML = originalButtonText || 'Browse Menu'; }
                    console.error('Cannot proceed: invalid fulfillment date/time selection');
                    alert('Please select a valid fulfillment date and time before proceeding.');
                    return;
                }
                
                const currentZipInput = document.getElementById('zip')?.value?.trim() || '';
                const selectedPickupRadio = document.querySelector('input[name="pickup-location"]:checked');
                const currentPickupLocationId = selectedPickupRadio ? selectedPickupRadio.getAttribute('data-location-id') || '' : '';
                const currentDeliveryType = getSelectedDeliveryOption();
                const fulfillmentConstants = window.FulfillmentConstants || {};
                const snapshot = (window.FulfillmentState && window.FulfillmentState._snapshot) || {};
                const committedZip = snapshot[fulfillmentConstants.ZIP_CODE || 'selected_zip_code'] || '';
                const committedLocationId = snapshot[fulfillmentConstants.LOCATION_ID || 'selected_location_id'] || '';
                const committedDeliveryType = snapshot[fulfillmentConstants.DELIVERY_TYPE || 'selected_delivery_type'] || '';

                const selectionChangedFromCommitted =
                    (currentDeliveryType === 'delivery' && currentZipInput !== committedZip) ||
                    (currentDeliveryType === 'pickup' && currentPickupLocationId !== committedLocationId) ||
                    (committedDeliveryType && currentDeliveryType !== committedDeliveryType);

                if (committedZip && selectionChangedFromCommitted) {
                    try {
                        let hasCartItems = false;
                        const cartResponse = await fetch('/cart.js');
                        const cart = await cartResponse.json();
                        if (cart.item_count > 0) hasCartItems = true;
                        // Subscription create page uses sidebar cart, not Shopify cart
                        if (!hasCartItems) {
                            try {
                                const sidebarRaw = localStorage.getItem('rechargeSidebarCart');
                                if (sidebarRaw) {
                                    const sidebar = JSON.parse(sidebarRaw);
                                    if (Array.isArray(sidebar) && sidebar.length > 0) hasCartItems = true;
                                }
                            } catch (e) {}
                        }
                        if (hasCartItems) {
                            if (browseButton) { browseButton.disabled = false; browseButton.classList.remove('loading'); browseButton.innerHTML = originalButtonText || 'Browse Menu'; }
                            showLocationChangeWarningModal();
                            return;
                        }
                    } catch (err) {
                        console.error('Failed to check cart status:', err);
                    }
                }
            
                // No changes or cart is empty, proceed immediately
                FulfillmentState._modalCancelled = false;
                FulfillmentState.commit();
                await executeBrowseMeals();
            } finally {
                setTimeout(() => {
                    isBrowseMealsExecuting = false;
                    const btn = document.querySelector('#browse-menu-button, .delivery-modal-continue-button');
                    if (btn) {
                        btn.disabled = false;
                        btn.classList.remove('loading');
                        btn.innerHTML = originalButtonText || 'Browse Menu';
                    }
                }, 500);
            }
        }
        
        // Make browseMeals globally accessible for onclick handlers
        window.browseMeals = browseMeals;

        function consumePendingFulfillmentRedirectUrl() {
            const pendingUrl = window.__etFulfillmentPostRedirectUrl;
            window.__etFulfillmentPostRedirectUrl = '';
            if (!pendingUrl || typeof pendingUrl !== 'string') {
                return '';
            }
            return normalizeToInternalPath(pendingUrl);
        }

        function normalizeToInternalPath(rawUrl) {
            if (!rawUrl || typeof rawUrl !== 'string') {
                return '';
            }
            const trimmed = rawUrl.trim();
            if (!trimmed) {
                return '';
            }
            try {
                const resolved = new URL(trimmed, window.location.origin);
                const isHttp = resolved.protocol === 'http:' || resolved.protocol === 'https:';
                const isSameOrigin = resolved.origin === window.location.origin;
                if (!isHttp || !isSameOrigin) {
                    return '';
                }
                return resolved.pathname + resolved.search + resolved.hash;
            } catch (error) {
                return '';
            }
        }

        function resolveMenuDestinationUrl() {
            const pendingUrl = consumePendingFulfillmentRedirectUrl();
            if (pendingUrl) {
                return pendingUrl;
            }

            const browseLink = document.querySelector('.browse-menu-button[href]');
            if (browseLink && browseLink.href) {
                const safeBrowseUrl = normalizeToInternalPath(browseLink.href);
                if (safeBrowseUrl) {
                    return safeBrowseUrl;
                }
            }

            const orderNowLink = document.querySelector('.order-now-btn[href]');
            if (orderNowLink && orderNowLink.href) {
                const safeOrderNowUrl = normalizeToInternalPath(orderNowLink.href);
                if (safeOrderNowUrl) {
                    return safeOrderNowUrl;
                }
            }

            return '/collections/menu';
        }

        function shouldRedirectToMenuAfterBrowse() {
            const pathname = window.location.pathname || '';
            const isProductPage = pathname.indexOf('/products/') !== -1;
            const isCollectionPage = pathname.indexOf('/collections/') !== -1 && pathname.indexOf('/products/') === -1;
            const isSubscriptionPage = pathname.indexOf('/pages/subscriptions') !== -1 ||
                pathname.indexOf('/pages/subscription') !== -1 ||
                pathname.indexOf('/pages/subscribe') !== -1 ||
                pathname.indexOf('/tools/recurring') !== -1;
            return !isProductPage && !isCollectionPage && !isSubscriptionPage;
        }

        function showLocationChangeWarningModal() {
            // Show the warning modal
            const warningModal = document.getElementById('location-change-warning-modal');
            if (warningModal) {
                warningModal.classList.remove('hidden');
            }

            // Hide delivery modal UI without triggering rollback
            document.getElementById('delivery-modal')?.classList.add('hidden');
        }

        async function executeBrowseMeals() {
            showLoadingOverlay(); // show spinner

            const selectedDeliveryType = getSelectedDeliveryOption();

            // Read form values and persist to localStorage BEFORE closing modal
            if (selectedDeliveryType === 'delivery') {
                const zipInput = document.querySelector('.delivery-modal-zip-code-input');
                const zipValue = zipInput?.value?.trim();
                if (zipValue && /^\d{5}$/.test(zipValue)) {
                    FulfillmentState.set('selected_zip_code', zipValue);
                }
                const fulfillmentDateSelect = document.getElementById('fulfillment-date-delivery');
                const fulfillmentTimeSelect = document.getElementById('fulfillment-time-delivery');
                const selectedFulfillmentDate = fulfillmentDateSelect ? fulfillmentDateSelect.value : null;
                const selectedFulfillmentTime = fulfillmentTimeSelect ? fulfillmentTimeSelect.value : null;
                if (selectedFulfillmentDate) {
                    FulfillmentState.set('selected_fulfillment_date', selectedFulfillmentDate);
                }
                if (selectedFulfillmentTime) {
                    FulfillmentState.set('selected_fulfillment_time', selectedFulfillmentTime);
                }
                if (selectedFulfillmentDate) {
                    dispatchCommittedFulfillmentDateChanged(selectedFulfillmentDate);
                }

                const zipToUse = zipValue || FulfillmentState.get('selected_zip_code');
                const zipLooksValid = /^\d{5}$/.test(String(zipToUse || '').trim());
                let resolvedDeliveryLocation = null;
                let resolvedTimeZone = '';

                if (zipLooksValid) {
                    const normalizedZip = String(zipToUse).trim();
                    const cachedZipPayload = getCachedZipData(normalizedZip);
                    if (cachedZipPayload && cachedZipPayload.deliveryLocation && cachedZipPayload.deliveryLocation.location_id && cachedZipPayload.deliveryLocation.name) {
                        resolvedDeliveryLocation = cachedZipPayload.deliveryLocation;
                        resolvedTimeZone = cachedZipPayload.locationTimeZone || '';
                    } else {
                        try {
                            const availabilityRes = await fetch(`${API_URL}/search/availability/${normalizedZip}`);
                            if (availabilityRes.ok) {
                                const availabilityData = await availabilityRes.json();
                                if (availabilityData && availabilityData.deliveryLocation && availabilityData.deliveryLocation.location_id && availabilityData.deliveryLocation.name) {
                                    resolvedDeliveryLocation = availabilityData.deliveryLocation;
                                    resolvedTimeZone = availabilityData.locationTimeZone || '';
                                    sessionStorage.setItem(`zipCache-${normalizedZip}`, JSON.stringify({ data: availabilityData, timestamp: Date.now() }));
                                }
                            }
                        } catch (e) {}
                    }
                }

                if (resolvedDeliveryLocation) {
                    FulfillmentState.set('selected_location_id', String(resolvedDeliveryLocation.location_id));
                    FulfillmentState.set('selected_location_name', resolvedDeliveryLocation.name);
                    if (resolvedTimeZone) {
                        FulfillmentState.set('selected_time_zone', resolvedTimeZone);
                    }
                }
            } else {
                const selectedRadio = document.querySelector('input[name="pickup-location"]:checked');
                if (selectedRadio) {
                    const name = selectedRadio.getAttribute('data-location-name');
                    const zip = selectedRadio.getAttribute('data-location-zip');
                    const locId = selectedRadio.getAttribute('data-location-id');

                    if (name) {
                        FulfillmentState.set('selected_location_name', name);
                    }
                    if (zip) {
                        // Keep ZIP aligned with selected pickup location for downstream availability/pricing.
                        FulfillmentState.set('selected_zip_code', zip);
                    }
                    if (locId) {
                        FulfillmentState.set('selected_location_id', locId);
                    }

                    // Handle pickup date selection and set pickup time to midnight.
                    const pickupDateSelect = document.getElementById('fulfillment-date-pickup');
                    const selectedPickupDate = pickupDateSelect ? pickupDateSelect.value : null;
                    if (selectedPickupDate && selectedPickupDate !== '') {
                        FulfillmentState.set('selected_fulfillment_date', selectedPickupDate);
                        dispatchCommittedFulfillmentDateChanged(selectedPickupDate);
                        FulfillmentState.set('selected_fulfillment_time', getPickupMidnightTime());
                    }

                    // Migrate zipCache to new zip (only remove old cache after successful fetch)
                    const oldZipCacheKey = Object.keys(sessionStorage).find(k => k.startsWith('zipCache-'));
                    try {
                        const newZipCacheKey = `zipCache-${zip}`;
                        const res = await fetch(`${API_URL}/search/availability/${zip}`);
                        if (res.ok) {
                            const data = await res.json();
                            Object.keys(sessionStorage).forEach((key) => {
                                if (key.startsWith('zipCache-')) {
                                    sessionStorage.removeItem(key);
                                }
                            });
                            sessionStorage.setItem(newZipCacheKey, JSON.stringify({ data, timestamp: Date.now() }));
                        }
                    } catch (err) {
                        if (typeof console !== 'undefined' && console.error) console.error('zipCache migration fetch failed:', err);
                    }
                }
            }

            closeDeliveryModal({ skipRender: true, skipRestore: true });

            dispatchCommittedLocationChanged();

            // Cache-first render: apply any already-fetched catalog prices immediately.
            if (window.LocationCatalogPricing) window.LocationCatalogPricing.refresh();
            dispatchCommittedLocationPricesReady();

            await maybeFetchCatalogPricing().finally(async () => {
                await syncAllAttributesToCart();

                const locationName = localStorage.getItem('selected_location_name');
                renderDeliverySummaryBar(locationName);

                await forceCartTransformRerun();
                hideLoadingOverlay();
                
                // Check subscription toggle and handle redirect
                const subscriptionToggle = document.getElementById('subscription-toggle');
                if (subscriptionToggle && subscriptionToggle.checked) {
                    window.location.href = '/pages/subscriptions';
                } else {
                    if (window.LocationCatalogPricing) window.LocationCatalogPricing.refresh();
                    if (typeof syncFulfillmentAttributesToAddForms === 'function') syncFulfillmentAttributesToAddForms();
                    dispatchCommittedLocationPricesReady();
                    setTimeout(function() {
                        if (window.LocationCatalogPricing) window.LocationCatalogPricing.refresh();
                    }, 300);

                    if (shouldRedirectToMenuAfterBrowse()) {
                        const destination = resolveMenuDestinationUrl();
                        if (destination) {
                            window.location.href = destination;
                            return;
                        }
                    }
                }
            });
        }

        async function forceCartTransformRerun() {

            // Step 1: Fetch current cart
            let cart;
            try {
                const res = await fetch('/cart.js');
                cart = await res.json();
            } catch (err) {
                console.error('Failed to fetch cart:', err);
                return;
            }

            if (!cart.items.length) {
                await updateCartCount();
                return;
            }

            const lineItems = cart.items.map((item, index) => {
                return {
                    id: item.variant_id,
                    quantity: item.quantity,
                    properties: item.properties || {}
                };
            });

            // Step 2: Clear cart
            try {
                await fetch('/cart/clear.js', { method: 'POST' });
            } catch (err) {
                console.error('Failed to clear cart:', err);
                return;
            }

            // Step 3: Re-add items
            try {
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: lineItems })
                });
                const updatedCart = await res.json();
            } catch (err) {
                console.error('Failed to re-add items to cart:', err);
            }

            // Step 4: Re-apply cart attributes (cleared by /cart/clear.js)
            // Force resync to bypass memoization; lastSyncedFulfillmentSignature may still match localStorage
            await syncAllAttributesToCart({ force: true });

            await updateCartCount();

        }

        function updateCartCount() {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    // Try different selectors that might contain the cart count
                    const cartCountSelectors = [
                        '.cart-count-bubble',
                        '.cart-count',
                        '#cart-icon-bubble',
                        '.header__cart-count',
                        '[data-cart-count]',
                        '.site-header__cart-indicator'
                    ];

                    cartCountSelectors.forEach(selector => {
                        const elements = document.querySelectorAll(selector);
                        if (elements.length > 0) {
                            elements.forEach(element => {
                                // If the element has a data attribute for the count
                                if (element.hasAttribute('data-cart-count')) {
                                    element.setAttribute('data-cart-count', cart.item_count);
                                }

                                // Update the text content if it's just a number
                                if (/^\d+$/.test(element.textContent.trim())) {
                                    element.textContent = cart.item_count;
                                } else {
                                    // Look for a child element that might contain just the number
                                    const countElement = element.querySelector('span');
                                    if (countElement && /^\d+$/.test(countElement.textContent.trim())) {
                                        countElement.textContent = cart.item_count;
                                    }
                                }
                            });
                        }
                    });

                    document.dispatchEvent(new CustomEvent('cart:updated', {
                        bubbles: true,
                        detail: { cart: cart }
                    }));
                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'delivery-modal', cartData: cart });
                    }
                })
                .catch(error => {});
        }
        
        function setCachedLocationPriceList(data) {
            try {
                const payload = {
                    timestamp: Date.now(),
                    data
                };
                localStorage.setItem(LOCATION_PRICE_CACHE_KEY, JSON.stringify(payload));
            } catch (e) {
            }
        }

        function getCatalogPricingCacheState(locationId, locationName) {
            if (!locationId) return { exists: false, isFresh: false, hasCatalogData: false };

            const cacheKey = `${LOCATION_CATALOG_CACHE_KEY}-${locationId}`;
            const raw = localStorage.getItem(cacheKey);
            if (!raw) return { exists: false, isFresh: false, hasCatalogData: false };

            try {
                const parsed = JSON.parse(raw);
                const timestamp = Number(parsed && parsed.timestamp);
                const ageMs = Number.isFinite(timestamp) ? (Date.now() - timestamp) : Number.POSITIVE_INFINITY;
                const catalog = (parsed && parsed.data && parsed.data.catalog) || parsed.catalog || null;
                const locationMatches = !locationName || !parsed.locationName || String(parsed.locationName) === String(locationName);
                return {
                    exists: true,
                    isFresh: ageMs >= 0 && ageMs < LOCATION_CATALOG_CACHE_TTL_MS && locationMatches,
                    hasCatalogData: !!catalog,
                    ageMs: ageMs
                };
            } catch (error) {
                return { exists: true, isFresh: false, hasCatalogData: false };
            }
        }

        function shouldEnsureCatalogPricing() {
            const locationId = localStorage.getItem("selected_location_id");
            const locationName = localStorage.getItem("selected_location_name");
            const selectedDate = localStorage.getItem("selected_fulfillment_date");
            const deliveryType = localStorage.getItem("selected_delivery_type");
            const zipCode = localStorage.getItem("selected_zip_code");
            if (!locationId || !locationName) return false;
            if (isFulfillmentDraftMode()) return false;
            if (selectedDate && deliveryType && zipCode) return true;
            if (window.FulfillmentState && typeof window.FulfillmentState.isReady === 'function' && window.FulfillmentState.isReady()) {
                return true;
            }
            if (window.LocationCatalogPricing && typeof window.LocationCatalogPricing.isLocationReady === 'function' && window.LocationCatalogPricing.isLocationReady()) {
                return true;
            }
            return false;
        }

        async function ensureCatalogPricingAvailable(options = {}) {
            const locationId = localStorage.getItem("selected_location_id");
            const locationName = localStorage.getItem("selected_location_name");

            if (!locationId || !locationName) return false;
            if (!shouldEnsureCatalogPricing()) return false;

            const cacheState = getCatalogPricingCacheState(locationId, locationName);
            if (!options.force && cacheState.exists && cacheState.isFresh && cacheState.hasCatalogData) {
                if (window.LocationCatalogPricing && typeof window.LocationCatalogPricing.refresh === 'function') {
                    window.LocationCatalogPricing.refresh();
                }
                return false;
            }

            await maybeFetchCatalogPricing({ allowUncommitted: true });
            return true;
        }


        document.addEventListener('DOMContentLoaded', function() {
            ensureCatalogPricingAvailable();
            
            // Auto-load customer data if logged in
            if (window.customerData && window.customerData.isLoggedIn && window.customerData.zip) {
                const savedZip = localStorage.getItem('selected_zip_code');
                
                // Only auto-search when nothing has been selected yet.
                if (!savedZip) {
                    // Set a flag to prevent infinite reload loops
                    const autoLoadFlag = sessionStorage.getItem('customer_zip_auto_loaded');
                    
                    if (!autoLoadFlag) {
                        sessionStorage.setItem('customer_zip_auto_loaded', 'true');
                        
                        // Simulate ZIP search
                        const zipInput = document.getElementById('zip');
                        if (zipInput) {
                            zipInput.value = window.customerData.zip;
                            // Trigger the search automatically
                            setTimeout(() => {
                                proceedToOptions();
                            }, 500);
                        }
                    }
                }
            }
        });

        var _catalogFetchInFlight = {};
        async function maybeFetchCatalogPricing(options = {}) {
            const locationId = localStorage.getItem("selected_location_id");
            const locationName = localStorage.getItem("selected_location_name");

            if (!locationId || !locationName) return;
            if (isFulfillmentDraftMode()) return;

            const fetchKey = `${locationId}:${locationName}`;
            if (_catalogFetchInFlight[fetchKey]) return _catalogFetchInFlight[fetchKey];

            var fetchPromise = (async function() {
                try {
                    const refreshLocationPricingSoon = function() {
                    const run = function() {
                        if (window.LocationCatalogPricing) window.LocationCatalogPricing.refresh();
                    };
                    run();
                    requestAnimationFrame(run);
                    setTimeout(run, 120);
                    setTimeout(run, 450);
                    setTimeout(run, 900);
                };

                const response = await fetch(`${API_URL}/location/catalog/${locationId}/${encodeURIComponent(locationName)}`);
                if (!response.ok) {
                    if (response.status === 404) {
                        return;
                    }
                    throw new Error(`Server error: ${response.status}`);
                }

                const json = await response.json();
                const catalog = json?.catalog;
                const prices = catalog?.prices || [];

                if (catalog && (prices.length > 0 || catalog.prices)) {
                    try {
                        const key = `location_catalog_json-${locationId}`;
                        localStorage.setItem(key, JSON.stringify({
                            data: { catalog: catalog },
                            timestamp: Date.now(),
                            locationId: String(locationId),
                            locationName: String(locationName || '')
                        }));
                    } catch (e) {}

                    const catalogRawId = (json && (json.catalogId || json.catalog_id)) ||
                        (catalog && (catalog.catalogId || catalog.catalog_id || catalog.id));
                    if (catalogRawId) {
                        const catalogUid = String(catalogRawId).split("/").pop();
                        const previousCatalogId = localStorage.getItem("selected_catalog_id");
                        FulfillmentState.set("selected_catalog_id", catalogUid);

                        // Force variant selection immediately so visible cards align with the active catalog.
                        if (typeof window.updateVariantFilter === 'function') {
                            window.updateVariantFilter(catalogUid);
                        } else {
                            window.dispatchEvent(new CustomEvent('catalogIdChanged', {
                                detail: { catalogId: catalogUid }
                            }));
                            window.dispatchEvent(new Event('variantFilterComplete'));
                        }

                        if (previousCatalogId !== catalogUid) {
                            document.dispatchEvent(new CustomEvent('catalogId:updated', {
                                detail: { catalogId: catalogUid }
                            }));
                        }
                    }
                }
                // Ensure pricing applies after variant visibility is updated.
                refreshLocationPricingSoon();
                dispatchCommittedLocationPricesReady();
                // Keep cart attributes in sync, but do not block price rendering on cart latency.
                syncAllAttributesToCart({ force: true });
                hideLoadingOverlay();
                } catch (error) {
                    console.error('Failed to fetch catalog pricing:', error);
                    hideLoadingOverlay();
                } finally {
                    delete _catalogFetchInFlight[fetchKey];
                    hideLoadingOverlay();
                }
            })();
            _catalogFetchInFlight[fetchKey] = fetchPromise;
            return fetchPromise;
        }

        function buildVariantPriceMap(prices) {
            return prices.reduce((acc, { price, variant }) => {
                const gid = variant?.id;
                if (!gid) return acc;

                const numericId = gid.split('/').pop();
                acc[numericId] = {
                    price: parseFloat(price.amount).toFixed(2),
                    currency: price.currencyCode
                };
                return acc;
            }, {});
        }


        function writeFreshZipCache(zipCode, data) {
            // Step 1: Clear all existing zipCache entries
            Object.keys(sessionStorage).forEach((key) => {
                if (key.startsWith('zipCache-')) {
                    sessionStorage.removeItem(key);
                }
            });

            // Step 2: Write new zipCache entry with timestamp for getCachedZipData expiry
            const cacheKey = `zipCache-${zipCode}`;
            sessionStorage.setItem(cacheKey, JSON.stringify({ data: data, timestamp: Date.now() }));
        }


        async function openDeliveryModalFromHeader() {
            FulfillmentState._modalCancelled = false;
            FulfillmentState.snapshot();
            deliveryOptionManuallyChosen = false;
            document.getElementById('delivery-step-two')?.classList.remove('hidden');
            document.querySelector('.delivery-modal-inner-wrapper')?.classList.add('options-view');

            const zipInput = document.getElementById('zip');
            if (zipInput) {
                zipInput.classList.remove('error');
            }
            hideZipError();
            let zipCode = localStorage.getItem('selected_zip_code');
            
            // Auto-load customer ZIP if logged in and no existing ZIP
            if (!zipCode && window.customerData && window.customerData.isLoggedIn && window.customerData.zip) {
                zipCode = window.customerData.zip;
            }

            if (!zipCode) {
                const zipMatch = Object.keys(sessionStorage).find((key) => key.startsWith('zipCache-'));
                zipCode = zipMatch ? zipMatch.replace('zipCache-', '') : null;
            }

            if (!zipCode) {
                zipCode = DEFAULT_DELIVERY_ZIP_CODE;
            }

            if (zipCode && zipInput) {
                zipInput.value = zipCode;
                window.originalZipCode = zipCode.trim();

                const cachedData = getCachedZipData(zipCode);
                if (cachedData) {
                    await processZipApiResponse(cachedData, zipCode);
                    setTimeout(() => {
                        updateBrowseButtonState();
                    }, 100);
                } else {
                    if (/^\d{5}$/.test(zipCode)) {
                        autoLoadZipOptions(zipCode);
                    }
                }
            }

            document.getElementById('delivery-modal')?.classList.remove('hidden');
            
            // Store original form values and update button state after modal is opened
            setTimeout(() => {
                storeOriginalFormValues();
                updateBrowseButtonState();
            }, 100);
        }
        
        // Make openDeliveryModalFromHeader globally accessible for onclick handlers
        window.openDeliveryModalFromHeader = openDeliveryModalFromHeader;


        function resetModalView() {
            const stepTwo = document.getElementById('delivery-step-two');
            const modalWrapper = document.querySelector('.delivery-modal-inner-wrapper');

            stepTwo.classList.remove('hidden');
            modalWrapper.classList.add('options-view');
        }

        function handleZipKeyDown(event){
            if(event.key === 'Enter'){
                proceedToOptions();
            }
        }
        window.handleZipKeyDown = handleZipKeyDown;

        function addOrUpdateFormAttribute(form, name, value) {
            if (value === '' || value === null) {
                const input = form.querySelector('input[name="attributes[' + name + ']"]');
                if (input) input.remove();
                return;
            }
            if (value === undefined) return;
            let input = form.querySelector('input[name="attributes[' + name + ']"]');
            if (!input) {
                input = document.createElement("input");
                input.type = "hidden";
                input.name = "attributes[" + name + "]";
                form.appendChild(input);
            }
            input.value = value;
        }

        function syncFulfillmentAttributesToAddForms() {
            const locationId = localStorage.getItem("selected_location_id");
            const fulfillmentType = localStorage.getItem("selected_delivery_type");
            const selectedZipCode = localStorage.getItem("selected_zip_code");
            const selectedFulfillmentDate = localStorage.getItem("selected_fulfillment_date");
            const selectedFulfillmentTime = localStorage.getItem("selected_fulfillment_time");
            const selectedTimeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";

            const forms = document.querySelectorAll('form[action="/cart/add"]');
            const attrKeys = ["LocationID", "Fulfillment Type", "_timeZone", "_zipCode", "_selectedFulfillmentDate", "_selectedFulfillmentTime", "Fulfillment Date"];

            forms.forEach((form) => {
                if (!locationId) {
                    attrKeys.forEach((key) => addOrUpdateFormAttribute(form, key, null));
                    return;
                }
                addOrUpdateFormAttribute(form, "LocationID", locationId);
                addOrUpdateFormAttribute(form, "Fulfillment Type", fulfillmentType);
                addOrUpdateFormAttribute(form, "_timeZone", selectedTimeZone);
                addOrUpdateFormAttribute(form, "_zipCode", selectedZipCode);
                addOrUpdateFormAttribute(form, "_selectedFulfillmentDate", selectedFulfillmentDate);
                addOrUpdateFormAttribute(form, "_selectedFulfillmentTime", selectedFulfillmentTime);
                if (selectedFulfillmentDate && selectedFulfillmentTime && typeof getLocalISOFromDateAndTime === 'function') {
                    const isoDateTime = getLocalISOFromDateAndTime(selectedFulfillmentDate, selectedFulfillmentTime, selectedTimeZone);
                    addOrUpdateFormAttribute(form, "Fulfillment Date", isoDateTime || '');
                } else {
                    addOrUpdateFormAttribute(form, "Fulfillment Date", '');
                }
            });
        }

        document.addEventListener("DOMContentLoaded", () => {
            syncFulfillmentAttributesToAddForms();

            const observer = new MutationObserver(() => {
                syncFulfillmentAttributesToAddForms();
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });

        function hydrateLocationInputs() {
            const locationId = localStorage.getItem("selected_location_id");
            const deliveryDate = localStorage.getItem("selected_fulfillment_date");
            const deliveryType = localStorage.getItem("selected_delivery_type");
            if (locationId){
                document.querySelectorAll('input[data-location-attribute]').forEach(input => {
                    input.value = locationId;
                });
            }

            if(deliveryDate){
                document.querySelectorAll('input[data-delivery-date-attribute]').forEach(input => {
                    input.value = deliveryDate;
                });
            }

        }

        document.addEventListener("DOMContentLoaded", hydrateLocationInputs);

        // Hydrate localStorage from cart when cart has fulfillment data but localStorage is empty/partial
        async function hydrateFromCartToLocalStorage() {
            const fc = window.FulfillmentConstants || {};
            const zipKey = fc.ZIP_CODE || 'selected_zip_code';
            const dateKey = fc.DATE || 'selected_fulfillment_date';
            const locKey = fc.LOCATION_ID || 'selected_location_id';
            const typeKey = fc.DELIVERY_TYPE || 'selected_delivery_type';
            const timeKey = fc.TIME || 'selected_fulfillment_time';
            const locNameKey = fc.LOCATION_NAME || 'selected_location_name';
            const tzKey = fc.TIME_ZONE || 'selected_time_zone';
            const hasLocalZip = !!localStorage.getItem(zipKey);
            const hasLocalDate = !!localStorage.getItem(dateKey);
            const hasLocalLoc = !!localStorage.getItem(locKey);
            const hasLocalType = !!localStorage.getItem(typeKey);
            const hasLocalTime = !!localStorage.getItem(timeKey);
            const hasLocalTz = !!localStorage.getItem(tzKey);
            const hasLocalLocName = !!localStorage.getItem(locNameKey);
            if (hasLocalZip && hasLocalDate && hasLocalLoc && hasLocalType && hasLocalTime && hasLocalTz && hasLocalLocName) return;
            let cart;
            try {
                const res = await fetch('/cart.js');
                cart = await res.json();
            } catch (e) { return; }
            if (!cart.items || cart.items.length === 0) return;
            const attrs = cart.attributes || {};
            const cartZip = attrs._zipCode;
            const cartDate = attrs._selectedFulfillmentDate;
            const cartLoc = attrs.LocationID;
            const cartType = attrs['Fulfillment Type'];
            const cartLocName = attrs._locationName;
            const cartTime = attrs._selectedFulfillmentTime;
            const cartTz = attrs._timeZone;
            if (!cartZip || !cartDate || !cartLoc || !cartType) return;
            const setStorage = (k, v) => {
                try {
                    if (window.FulfillmentState && typeof window.FulfillmentState.set === 'function') {
                        window.FulfillmentState.set(k, v);
                    } else {
                        localStorage.setItem(k, v);
                    }
                } catch (e) {}
            };
            try {
                if (!hasLocalZip && cartZip) setStorage(zipKey, cartZip);
                if (!hasLocalDate && cartDate) setStorage(dateKey, cartDate);
                if (!hasLocalLoc && cartLoc) setStorage(locKey, String(cartLoc));
                if (!hasLocalType && cartType) setStorage(typeKey, cartType);
                if (!localStorage.getItem(locNameKey) && cartLocName) setStorage(locNameKey, cartLocName);
                if (!localStorage.getItem(timeKey) && cartTime) setStorage(timeKey, cartTime);
                if (!localStorage.getItem(tzKey) && cartTz) setStorage(tzKey, cartTz);
            } catch (e) {}
        }

        async function reconcileExistingUserCartAndStorage() {
            const fulfillmentConstants = window.FulfillmentConstants;
            if (!fulfillmentConstants) return;
            const dateKey = fulfillmentConstants.DATE || 'selected_fulfillment_date';
            const locKey = fulfillmentConstants.LOCATION_ID || 'selected_location_id';
            const typeKey = fulfillmentConstants.DELIVERY_TYPE || 'selected_delivery_type';
            const timeKey = fulfillmentConstants.TIME || 'selected_fulfillment_time';
            const zipKey = fulfillmentConstants.ZIP_CODE || 'selected_zip_code';
            const date = localStorage.getItem(dateKey);
            const locId = localStorage.getItem(locKey);
            const type = localStorage.getItem(typeKey);
            const time = localStorage.getItem(timeKey);
            const zip = localStorage.getItem(zipKey);
            if (!date || !locId || !type || !zip) return;
            // For delivery, time is mandatory - do not auto-commit without it
            if (type === 'delivery' && !time) return;
            let cart;
            try {
                const res = await fetch('/cart.js');
                cart = await res.json();
            } catch (e) { return; }
            if (!cart.items || cart.items.length === 0) return;
            const attrs = cart.attributes || {};
            const hasZip = attrs._zipCode && String(attrs._zipCode).trim();
            const hasDate = attrs._selectedFulfillmentDate && String(attrs._selectedFulfillmentDate).trim();
            const hasLoc = attrs.LocationID && String(attrs.LocationID).trim();
            const hasType = attrs['Fulfillment Type'] && String(attrs['Fulfillment Type']).trim();
            const hasTimeOrIso = (attrs._selectedFulfillmentTime && String(attrs._selectedFulfillmentTime).trim()) ||
                (attrs['Fulfillment Date'] && String(attrs['Fulfillment Date']).trim());
            if (hasZip && hasDate && hasLoc && hasType && (type !== 'delivery' || hasTimeOrIso)) {
                return;
            }
            if (typeof syncAllAttributesToCart === 'function') {
                try {
                    await syncAllAttributesToCart();
                } catch (e) {
                    console.error('reconcileExistingUserCartAndStorage: sync failed', e);
                }
            }
        }

        async function tryRenderSummaryBar() {
            await hydrateFromCartToLocalStorage();
            await ensureFreshFulfillmentSelection({ syncCart: true, rerenderSummary: false });
            await reconcileDeliveryLocationFromZip({ syncCart: true });
            await reconcileExistingUserCartAndStorage();
            if (typeof ensureCatalogPricingAvailable === 'function') {
                await ensureCatalogPricingAvailable();
            }
            const fulfillmentConstants = window.FulfillmentConstants;
            const locationName = localStorage.getItem(fulfillmentConstants && fulfillmentConstants.LOCATION_NAME ? fulfillmentConstants.LOCATION_NAME : 'selected_location_name');
            const locationId = localStorage.getItem(fulfillmentConstants && fulfillmentConstants.LOCATION_ID ? fulfillmentConstants.LOCATION_ID : 'selected_location_id');
            const zipCode = localStorage.getItem(fulfillmentConstants && fulfillmentConstants.ZIP_CODE ? fulfillmentConstants.ZIP_CODE : 'selected_zip_code') || '';
            const date = localStorage.getItem(fulfillmentConstants && fulfillmentConstants.DATE ? fulfillmentConstants.DATE : 'selected_fulfillment_date');
            const deliveryType = localStorage.getItem(fulfillmentConstants && fulfillmentConstants.DELIVERY_TYPE ? fulfillmentConstants.DELIVERY_TYPE : 'selected_delivery_type');

            if (!locationName || !locationId || !zipCode || !date || !deliveryType) return;

            await renderDeliverySummaryBar(locationName);
            if (typeof syncAllAttributesToCart === 'function') {
                syncAllAttributesToCart();
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', tryRenderSummaryBar);
        } else {
            tryRenderSummaryBar();
        }

        async function refreshCatalogPricingAfterResume() {
            if (_resumeCatalogRefreshInFlight) return _resumeCatalogRefreshInFlight;
            _resumeCatalogRefreshInFlight = (async function () {
                if (typeof ensureFreshFulfillmentSelection === 'function') {
                    await ensureFreshFulfillmentSelection({ syncCart: true, rerenderSummary: true });
                }
                await reconcileExistingUserCartAndStorage();
                await ensureCatalogPricingAvailable();
            })().finally(function () {
                _resumeCatalogRefreshInFlight = null;
            });
            return _resumeCatalogRefreshInFlight;
        }

        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
                refreshCatalogPricingAfterResume();
            }
        });

        window.addEventListener('focus', function () {
            refreshCatalogPricingAfterResume();
        });

        window.addEventListener('pageshow', function () {
            refreshCatalogPricingAfterResume();
        });


        async function updateCartAttribute(attributeKey, attributeValue) {
            try {
                const res = await fetch('/cart.js');
                const cart = await res.json();
                const existingAttributes = cart.attributes || {};

                const updatedAttributes = {
                    ...existingAttributes,
                    [attributeKey]: attributeValue
                };

                const updateRes = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: updatedAttributes })
                });

                const updatedCart = await updateRes.json();
                return updatedCart;
            } catch (error) {
                console.error(`Failed to update cart attribute "${attributeKey}":`, error);
            }
        }

        function updateRechargeCardDiscounts() {
          document.querySelectorAll('.recharge-card__price--discount').forEach(function(greenEl) {
            // Find the closest card and its grey price
            const card = greenEl.closest('.recharge-card');
            if (!card) return;
            const greyEl = card.querySelector('.price-item');
            if (!greyEl) return;
            // Parse price
            const greyText = greyEl.textContent.replace(/[^\d.]/g, '');
            const greyPrice = parseFloat(greyText);
            if (isNaN(greyPrice)) return;
            // Calculate 10% off
            const discountPrice = (greyPrice * 0.9).toFixed(2);
            greenEl.textContent = `$${discountPrice}`;
          });
        }
        window.updateRechargeCardDiscounts = updateRechargeCardDiscounts;

        async function fetchCartForValidation() {
            const response = await fetch('/cart.js');
            if (!response.ok) return null;
            return response.json();
        }

        async function validateCartInventory(cart) {
            const fulfillmentDate = cart.attributes?._selectedFulfillmentDate;
            const locationId = cart.attributes?.LocationID;

            if (!fulfillmentDate || !locationId) {
                return false;
            }

            // Check if fulfillment date is today (using store timezone)
            const timeZone = localStorage.getItem("selected_time_zone") || "America/Los_Angeles";
            const now = new Date();
            
            let todayInStoreStr;
            try {
                const dateFormatter = new Intl.DateTimeFormat("en-CA", {
                    timeZone: timeZone,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                todayInStoreStr = dateFormatter.format(now).replace(/\//g, "-");
            } catch (err) {
                console.error('Error getting today in store timezone:', err);
                // Fallback to browser timezone
                todayInStoreStr = now.getFullYear() + '-' + 
                                  String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                                  String(now.getDate()).padStart(2, '0');
            }
            
            const isToday = fulfillmentDate === todayInStoreStr;

            if (!isToday) {
                return true;
            }

            let inventoryData = null;

            try {
                const locationIdToSearch = locationId.includes("gid://shopify/Location/")
                    ? locationId.replace("gid://shopify/Location/", "")
                    : locationId;

                const response = await fetch(`${API_URL}/location/${locationIdToSearch}/inventory`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                inventoryData = await response.json();

                const cacheData = {
                    data: inventoryData,
                    timestamp: Date.now(),
                    locationId: locationIdToSearch
                };
                // Clear old inventory entries and save to sessionStorage
                for (let i = sessionStorage.length - 1; i >= 0; i--) {
                    const sk = sessionStorage.key(i);
                    if (sk && sk.startsWith('inventory_data_') && sk !== `inventory_data_${locationIdToSearch}`) {
                        sessionStorage.removeItem(sk);
                    }
                }
                sessionStorage.setItem(`inventory_data_${locationIdToSearch}`, JSON.stringify(cacheData));

            } catch (error) {
                console.error('Error fetching fresh inventory data:', error);

                const cacheKey = `inventory_data_${locationId.replace('gid://shopify/Location/', '')}`;
                const cachedData = sessionStorage.getItem(cacheKey);

                if (cachedData) {
                    try {
                        const parsed = JSON.parse(cachedData);
                        inventoryData = parsed.data;
                    } catch (cacheError) {
                        console.error('Error parsing cached inventory data:', cacheError);
                    }
                }
            }

            if (!inventoryData || !inventoryData.products) {
                return true;
            }

            for (const item of cart.items) {
                const variantId = item.variant_id.toString();
                const quantity = item.quantity;

                if (item.gift_card) continue;

                let availableQuantity = 0;
                let found = false;

                for (const productId in inventoryData.products) {
                    const product = inventoryData.products[productId];
                    if (product.variants && product.variants[variantId]) {
                        found = true;

                        const isPayItForward = product.collections?.some((collection) =>
                            collection.handle === 'pay-it-forward-collection' ||
                            collection.handle === 'pay-it-forward'
                        );

                        if (isPayItForward) {
                            availableQuantity = 999;
                        } else {
                            let toGoInventory = null;
                            for (const variantIdKey in product.variants) {
                                const variant = product.variants[variantIdKey];
                                if (variant && variant.inventory) {
                                    toGoInventory = variant.inventory;
                                    break;
                                }
                            }
                            availableQuantity = toGoInventory?.available || 0;
                        }
                        break;
                    }
                }

                if (found && quantity > availableQuantity) {
                    return false;
                }
            }

            return true;
        }

        function clearInventoryCacheBeforeCheckout(options = {}) {
            const rawLocationId = options.locationId
                || (window.inventoryValidator && typeof window.inventoryValidator.getSelectedLocationId === 'function'
                    ? window.inventoryValidator.getSelectedLocationId()
                    : localStorage.getItem('selected_location_id'))
                || '';
            const normalizedLocationId = typeof rawLocationId === 'string' && rawLocationId.includes('gid://shopify/Location/')
                ? (rawLocationId.split('/').pop() || '')
                : String(rawLocationId || '').trim();

            try {
                if (window.cartWatcher && typeof window.cartWatcher.clearInventoryCache === 'function') {
                    window.cartWatcher.clearInventoryCache(normalizedLocationId || null);
                } else if (normalizedLocationId) {
                    sessionStorage.removeItem(`inventory_data_${normalizedLocationId}`);
                } else {
                    for (let i = sessionStorage.length - 1; i >= 0; i--) {
                        const key = sessionStorage.key(i);
                        if (key && key.indexOf('inventory_data_') === 0) {
                            sessionStorage.removeItem(key);
                        }
                    }
                }
            } catch (error) {}

            if (window.inventoryChecker) {
                window.inventoryChecker.inventoryData = null;
                window.inventoryChecker._cartSnapshot = null;
                window.inventoryChecker._cartSnapshotAt = 0;
            }

            if (window.inventoryValidator) {
                window.inventoryValidator.inventoryData = null;
                window.inventoryValidator._cartSnapshot = null;
                window.inventoryValidator._cartSnapshotAt = 0;
                if (window.inventoryValidator._inventoryPrefetchPromises) {
                    window.inventoryValidator._inventoryPrefetchPromises = {};
                }
            }

            try {
                window.__ET_INVENTORY_CACHE_CLEARED_AT = Date.now();
            } catch (error) {}
        }

        window.clearEverytableInventoryCache = clearInventoryCacheBeforeCheckout;

        // Show error state on checkout button
        function showCheckoutError(button, message) {
            // Add error class
            button.classList.add('checkout-validation-error');
            
            // Remove any existing error message
            const existingError = button.querySelector('.checkout-error-message');
            if (existingError) {
                existingError.remove();
            }
            
            // Create and add error message
            const errorMessage = document.createElement('div');
            errorMessage.className = 'checkout-error-message';
            errorMessage.textContent = message;
            button.style.position = 'relative';
            button.appendChild(errorMessage);
            
            // Remove error state after 3 seconds
            setTimeout(() => {
                button.classList.remove('checkout-validation-error');
                errorMessage.remove();
            }, 3000);
        }

        async function validateCheckoutReadiness() {
            try {
                const cart = await fetchCartForValidation();
                if (!cart) {
                    return { ok: false, type: 'missing_attribute', message: 'Please complete delivery information' };
                }
                const attributes = cart.attributes || {};

                const isValidValue = (value) => {
                    return value && value !== 'undefined' && value !== 'null' && value.trim() !== '';
                };

                const hasOnlyGiftCards = cart.items && cart.items.length > 0 &&
                    cart.items.every(item => item.gift_card === true);
                if (hasOnlyGiftCards) {
                    return { ok: true, type: 'ok' };
                }

                const gate = window.EtFulfillmentGate;
                if (!gate || typeof gate.validateForAction !== 'function') {
                    return { ok: false, type: 'missing_attribute', message: 'Please complete delivery information' };
                }

                const gateResult = await gate.validateForAction();
                if (!gateResult || gateResult.ok !== true) {
                    return { ok: false, type: 'missing_attribute', message: 'Please complete delivery information' };
                }

                const validatedCart = gateResult.cart || cart;
                const validatedAttributes = validatedCart.attributes || {};

                if (!isValidValue(validatedAttributes._selectedFulfillmentDate)) return { ok: false, message: 'Please select a delivery date', type: 'missing_attribute' };
                if (!isValidValue(validatedAttributes._zipCode)) return { ok: false, message: 'Please enter your ZIP code', type: 'missing_attribute' };
                if (!isValidValue(validatedAttributes.LocationID)) return { ok: false, message: 'Please select a location', type: 'missing_attribute' };
                if (!isValidValue(validatedAttributes['Fulfillment Type'])) return { ok: false, message: 'Please select delivery or pickup', type: 'missing_attribute' };
                if (!isValidValue(validatedAttributes._timeZone)) return { ok: false, message: 'Please complete delivery information', type: 'missing_attribute' };
                if (!isValidValue(validatedAttributes['Fulfillment Date'])) {
                    return {
                        ok: false,
                        message: validatedAttributes['Fulfillment Type'] === 'delivery'
                            ? 'Please select a delivery time'
                            : 'Please complete your pickup selection',
                        type: 'missing_attribute'
                    };
                }

                const hasValidInventory = await validateCartInventory(validatedCart);
                if (!hasValidInventory) {
                    return { 
                        ok: false,
                        message: 'Some items in your cart are no longer available. Please review your cart.', 
                        type: 'inventory_error' 
                    };
                }

                return { ok: true, type: 'ok' };
            } catch (error) {
                return { ok: false, message: 'Please complete delivery information', type: 'missing_attribute' };
            }
        }

        function setupCheckoutValidation() {
            document.addEventListener('click', async function(e) {
                const checkoutButton = e.target.closest('#checkout, #CartDrawer-Checkout');

                if (checkoutButton) {
                    e.preventDefault();
                    e.stopPropagation();

                    checkoutButton.disabled = true;
                    const originalText = checkoutButton.textContent;
                    checkoutButton.textContent = 'Validating...';

                    const checkoutValidation = await validateCheckoutReadiness();
                    if (!checkoutValidation.ok) {
                        checkoutButton.disabled = false;
                        checkoutButton.textContent = originalText;

                        const message = checkoutValidation.message || 'Please complete delivery information';
                        const errorType = checkoutValidation.type || 'missing_attribute';

                        showCheckoutError(checkoutButton, message);

                        // Only open delivery modal if cart attributes are missing
                        if (errorType === 'missing_attribute') {
                            setTimeout(() => {
                                openDeliveryModalFromHeader();
                            }, 500);
                        } else if (errorType === 'inventory_error') {
                            // For inventory errors, open the cart drawer so user can see the issue
                            setTimeout(() => {
                                const cartDrawer = document.querySelector('cart-drawer');
                                if (cartDrawer && typeof cartDrawer.open === 'function') {
                                    cartDrawer.open();
                                }
                            }, 500);
                        }

                        return false;
                    }

                    checkoutButton.disabled = false;
                    checkoutButton.textContent = originalText;
                    clearInventoryCacheBeforeCheckout();
                    window.location.href = checkoutButton.getAttribute('href') || '/checkout';
                }
            });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupCheckoutValidation);
        } else {
            setupCheckoutValidation();
        }

        // Debounce timer for summary bar updates
        let summaryBarUpdateTimer = null;

        // Listen for cart updates from inventory validation
        window.addEventListener('cart_updated', async function(event) {
            const { cart, inventoryIssues } = event.detail;
            
            // Update cart count display
            updateCartCountFromDeliveryModal();
            
            // Debounce summary bar re-render to prevent multiple rapid updates
            if (summaryBarUpdateTimer) {
                clearTimeout(summaryBarUpdateTimer);
            }
            
            summaryBarUpdateTimer = setTimeout(async () => {
                const locationName = localStorage.getItem('selected_location_name');
                if (locationName) {
                    await renderDeliverySummaryBar(locationName);
                }
            }, 300); // 300ms debounce
            
            // If there were inventory issues, refresh the inventory display
            if (inventoryIssues && inventoryIssues.length > 0) {
                if (window.inventoryChecker && typeof window.inventoryChecker.refreshInventory === 'function') {
                    setTimeout(() => {
                        window.inventoryChecker.refreshInventory();
                    }, 1000);
                }
            }
        });

        // ---------------------------------------------------------------
        // Public surface of this file.
        //
        // Before SHOPIFY-1GH these names reached other files implicitly: the
        // whole file sat in a bare block, so every function declaration got an
        // Annex B var-scoped alias in script scope, which a classic script turns
        // into a global. The IIFE removes that side effect, so anything consumed
        // from outside has to be exported here. Check for consumers before
        // dropping an entry -- the guarded ones fail silently, not loudly.
        // ---------------------------------------------------------------
        // snippets/delivery-modal.liquid, inline onclick (throws if missing)
        window.closeUnavailableModal = closeUnavailableModal;
        window.submitNotifyEmail = submitNotifyEmail;
        // behind `typeof === 'function'` guards: silently no-op if missing
        window.syncAllAttributesToCart = syncAllAttributesToCart;   // fulfillment-gate.js, fulfillment-state.js, cart-drawer.js, collection-with-filters.liquid, recharge-product-grid.liquid
        window.executeBrowseMeals = executeBrowseMeals;             // snippets/cart-location-utils.liquid
        window.maybeFetchCatalogPricing = maybeFetchCatalogPricing; // snippets/cart-location-utils.liquid
        window.renderDeliverySummaryBar = renderDeliverySummaryBar; // snippets/cart-location-utils.liquid
        window.getLocalISOFromDateAndTime = getLocalISOFromDateAndTime; // sections/recharge-product-grid.liquid
})();
